import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux"; 
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next"  
import { useNavigate } from 'react-router-dom'; 
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { ENDPOINT } from "constants/variables";
import { TEXT_SIGN_1,TEXT_SIGN_2,TEXT_SIGN_3,TEXT_SIGN_4,TEXT_SIGN_5,CLIENTEFIRMA,CANVAS_SIZE,CLIENT_CANVAS_WIDTH, CLIENT_CANVAS_HEIGHT } from "constants/variables";
import { es } from 'date-fns/locale';
import Box from '@mui/material/Box'; 
import Button from '@mui/material/Button'; 
import Card from '@mui/material/Card';  
import CardContent from '@mui/material/CardContent'; 
import CircularProgress from '@mui/material/CircularProgress'; 
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle'; 
import IconButton from '@mui/material/IconButton';  
import MenuItem  from "@mui/material/MenuItem";  
import SearchIcon from '@mui/icons-material/Search';
import SignatureCanvas from 'react-signature-canvas'; 
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';  
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import { NumericFormat } from 'react-number-format';  
import { successErrorAction,warningErrorAction } from "actions/ErrorActions"; 
import "css/empButtons.css";
import "css/generalSettings.css";
import "css/customDialog.css";
import PurchaseDeliverySearchStores from "pages/purchaseDelivery/editOrNewPurchaseDelivery/PurchaseDeliverySearchStores";
import PurchaseDeliverySearchVehicles from "pages/purchaseDelivery/editOrNewPurchaseDelivery/PurchaseDeliverySearchVehicles";
import PurchaseDeliverySearchStoresAddresses from "pages/purchaseDelivery/editOrNewPurchaseDelivery/PurchaseDeliverySearchStoresAddress";
import PurchaseDeliverySearchArticles from "pages/purchaseDelivery/editOrNewPurchaseDelivery/PurchaseDeliverySearchArticles";
import TableSortingPurchaseDeliveryArticleList from "pages/purchaseDelivery/editOrNewPurchaseDelivery/SortingTablesPurchaseDeliveryArticlesList";
import PurchaseDeliverySearchDI from "pages/purchaseDelivery/editOrNewPurchaseDelivery/PurchaseDeliverySearchDI"; 
import signKirian from "components/photos/kirian.png";
import signFrancisco from "components/photos/signs/Francisco.png"; 
import signGonzalo from "components/photos/signs/Gonzalo.png"; 
import signGuillermo from "components/photos/signs/Guillermo.png"; 
import signJorge from "components/photos/signs/Jorge.png"; 
import signBentahor from "components/photos/signs/Bentahor/SelloBentahor.png"; 
import signDiego from "components/photos/signs/Bentahor/SelloDiego.png"; 
import signMario from "components/photos/signs/Bentahor/SelloMario.png"; 
import signRoberto from "components/photos/signs/Bentahor/SelloRoberto.png"
import signSantiago from "components/photos/signs/Bentahor/SelloSantiago.png"; 
import PropTypes from 'prop-types';

const initialStatePurchaseDelivery = {
  "id" : "",
  "defaultStore_id":0, 
  "tradename": "",
  "useraccount_id":0,
  "username": "",
  "defaultformatnumber":1,
  "isfinished":false, 
  "purchasenote":0, 
  "numberticket":0, 
  "ownnumberpurchase":"", 
  "datepurchase": null, 
  "vehiclestore_id": 0,
  "vehiclestore_licenseplate": "",
  "vehiclestore_defaultdriver": "",
  "vehiclestore_store_id": 0,

  "rel_trans_store_id": 0,
  "rel_trans_documnettype_id": 0,
  "rel_trans_documentid": "",
  "rel_trans_documnettype_name": "",
  "rel_trans_tradename": "",
  "rel_trans_name": "",
  "rel_trans_contacperson": "",
  "rel_trans_nima": "",
  "rel_trans_pygr": "",
  "rel_trans_grnp":"",
  "rel_trans_opt": 0,
  "rel_trans_roadtype_id": 74,
  "rel_trans_street": "",
  "rel_trans_country_id": 1,
  "rel_trans_country_name":"",
  "rel_trans_province_id": 30,
  "rel_trans_province_name":"",
  "rel_trans_postalcode_id": 6911,
  "rel_trans_postalcode_code":"",
  "rel_trans_postalcode_name":"",

  "ori_tras_store_id": 0,
  "ori_tras_documnettype_id": 0,
  "ori_tras_documnettype_name": "",
  "ori_tras_documentid": "",
  "ori_tras_tradename": "",
  "ori_tras_name": "",
  "ori_tras_contacperson": "",
  "ori_tras_nima": "",
  "ori_tras_pygr": "",
  "ori_tras_grnp":"",
  "ori_tras_opt": 0,
  "ori_tras_workplace": "",
  "ori_tras_roadtype_id": 74,
  "ori_tras_street": "",
  "ori_tras_country_id": 1,
  "ori_tras_country_name": "",
  "ori_tras_province_id": 30,
  "ori_tras_province_name": "",
  "ori_tras_postalcode_id": 6911,
  "ori_tras_postalcode_code": "",
  "ori_tras_postalcode_name": "",
  "ori_tras_email": "",

  "observations": "",
  "totalpurchasedelivery": 0,
  "totaldiscountpurchasedelivery": 0,
  "totaltaxespurchasedelivery":0,
  "totalNetoPurchasedelivery":0,
  "enabled":true,
  "subownnumberpurchase":0,
  "payment_id" : 2 ,
  "payment_code": "",
  "payment_namees": "",
  "payment_nameen": "",
  "totalWeigthNeto":0,
  "signature_dispatched_by":"",
  "signature_client":"",

  "linespurchasedelivery":[]
};

const initialPaymentToSelect = [{
  "id": "",
  "code": "",
  "namees": "",
  "nameen": "",
}];

const initialPostalCodesToSelect = [{
    "id":6911,
    "postalcode":"",
    "name":"",
    "postalcodename":"",
    "enabled":true,
    "province_id":30,
    "province_name":""
}];

const initialArticlesToSelect = {
  "id": 0,
  "indexrowarticle":0, 
  "purchase_id":0,
  "article_id":0,
  "article_code": "",
  "article_namees": "",
  "article_nameen": "",
  "datepurchase": null,
  "estimatedprice": 0,
  "amount": 0,
  "discount":0,
  "tax":0,
  "taxincluded":false, 
  "total":0,
  "ticketweight":true,
  "formdi_id":0,
  "ownformdi_id":0
  
}; 

const initialVehicleToSelect = [{
  "id": "",
  "licenseplate": "" 
}];

const initialWorkPlaceToSelect = [{
  "id": "",
  "workplace": "" 
}];

const initialDocumentIdToSelect = [{
  "id": "",
  "documentid": "",
  "tradename": ""
}]; 
  
const PurchaseDeliveryEditOrCreate = ({id, showModalPurchasesDeliverySettings,typeOfList,setTrasporterId,setOritrasId}) => {
  const {t,i18n} = useTranslation(['listDataPurchases']);
  const token = useSelector((state) => state.loginUser.token);  
  const roles = useSelector((state) => state.loginUser.roles);  
  const defaultStore = useSelector((state) => state.loginUser.defaultStore)
  const useraccount_id = useSelector((state) => state.loginUser.useraccount_id);  
  const defaulttypesdi = useSelector((state) => state.loginUser.defaulttypesdi.formatnumber);  
  const LIMITPAGESIZE = useSelector((state) => state.loginUser.defaultticketsformat.limitpagesize);
  const DELETE_CODE = useSelector((state) => state.formatDIUser.delete_code); 
  const DEFAULTTYPEOFDOCUMENT = useSelector((state) => state.formatDIUser.default_documenttype); 
  const DEFAULTROADTYE = useSelector((state) => state.formatDIUser.default_roadtype); 
  const DEFAULTCOUNTRY = useSelector((state) => state.formatDIUser.default_country); 
  const DEFAULTCOUNTRY_NAME = useSelector((state) => state.formatDIUser.default_country_name); 
  const DEFAULTPROVINCE = useSelector((state) => state.formatDIUser.default_province); 
  const DEFAULTPROVINCE_NAME = useSelector((state) => state.formatDIUser.default_province_name); 
  const DEFAULTPOSTALCODE_ID = useSelector((state) => state.formatDIUser.default_postalcode); 
  const DEFAULTPOSTALCODE_CODE = useSelector((state) => state.formatDIUser.default_postalcode_code); 
  const DEFAULTPOSTALCODE_NAME = useSelector((state) => state.formatDIUser.default_postalcode_name); 
  
  const articlesButtonsList = useSelector((state) => state.loginUser.defaultticketsformat.articlesButtonsList);
  const dispatch = useDispatch();
  const navigate = useNavigate(); 
  const [formPurchaseDelivery, setFormPurchaseDelivery] = useState(initialStatePurchaseDelivery);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [isLoadingErrorData, setIsLoadingErrorData] = useState(false);
  const [errorsForm, setErrorsForm] = useState({});
  const [tetxtSearch, setTetxtSearch] = useState("Rel_Trans");  
  const [idCodeDeletePurchaseDelivery, setIdCodeDeletePurchaseDelivery] = useState(DELETE_CODE);
  const [showModalSearchStores, setShowModalSearchStores] = useState(false); 
  const [showModalSearchVehicles, setShowModalSearchVehicles] = useState(false);  
  const [showModalSearchStoresAddress, setShowModalSearchStoresAddress] = useState(false);  
  const [showModalSearchArticles, setShowModalSearchArticles] = useState(false); 
  const [openDeleteRowArticles,setOpenDeleteRowArticles]= useState(false);
  const [editRowArticles, setEditRowArticles] = useState(initialArticlesToSelect); 
  const [postalCodeOriToSelect,setPostalCodeOriToSelect]= useState(initialPostalCodesToSelect);  
  const [paymenetTypeSelect,setPaymenetTypeSelect]= useState(initialPaymentToSelect); 
  const [showModalSearchDI, setShowModalSearchDI] = useState(false);  
  const [vehiclesToSelect,setVehiclesToSelect]= useState(initialVehicleToSelect); 
  const [filteredVehicle, setFilteredVehicle] = useState([]); // Opciones filtradas
  const [highlightedIndexVehicle, setHighlightedIndexVehicle] = useState(-1); // Índice de la opción resaltada 
  const [documentIdToSelect,setDocumentIdToSelect]= useState(initialDocumentIdToSelect);  
  const [filteredDocumentId, setFilteredDocumentId] = useState([]); // Opciones filtradas
  const [highlightedIndexDocumentId, setHighlightedIndexDocumentId] = useState(-1); // Índice de la opción resaltada 
  const [tradenameToSelect,setTradenameToSelect]= useState(initialDocumentIdToSelect);  
  const [filteredTradename, setFilteredTradename] = useState([]); // Opciones filtradas
  const [highlightedIndexTradename, setHighlightedIndexTradename] = useState(-1); // Índice de la opción resaltada 
  const [documentIdOriToSelect,setDocumentIdOriToSelect]= useState(initialDocumentIdToSelect);  
  const [filteredDocumentIdOri, setFilteredDocumentIdOri] = useState([]); // Opciones filtradas
  const [highlightedIndexDocumentIdOri, setHighlightedIndexDocumentIdOri] = useState(-1); // Índice de la opción resaltada 
  const [tradenameOriToSelect,setTradenameOriToSelect]= useState(initialDocumentIdToSelect);  
  const [filteredTradenamedOri, setFilteredTradenamedOri] = useState([]); // Opciones filtradas
  const [highlightedIndexTradenamedOri, setHighlightedIndexTradenamedOri] = useState(-1); // Índice de la opción resaltada 
  const [workPlaceToSelect,setWorkPlaceToSelect]= useState(initialWorkPlaceToSelect);  
  const [filteredWorkPlace, setFilteredWorkPlace] = useState([]); // Opciones filtradas
  const [highlightedIndexWorkPlace, setHighlightedIndexWorkPlace] = useState(-1); // Índice de la opción resaltada 
  const [filteredpostalCodeOri, setFilteredpostalCodeOri] = useState([]); // Opciones filtradas
  const [highlightedIndexPostalCodeOri, setHighlightedIndexPostalCodeOri] = useState(-1); // Índice de la opción resaltada 
  const signDispatchedOptTrasCanvas = useRef(null);
  const signDispatchedDestTrasCanvas = useRef(null)

  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showModalPurchasesDeliverySettings) {
        setFormPurchaseDelivery(formPurchaseDelivery => ({
          ...formPurchaseDelivery,
          linespurchasedelivery: [],
        }));
        setFormPurchaseDelivery(initialStatePurchaseDelivery);
        dispatch(setLoading(false));
        setIsLoadingErrorData(false);
        setErrorsForm({});
        setTetxtSearch("Rel_Trans ");   
        setIdCodeDeletePurchaseDelivery(DELETE_CODE);
        setShowModalSearchStores(false);
        setShowModalSearchVehicles(false);
        setShowModalSearchStoresAddress(false);
        setShowModalSearchArticles(false); 
        setOpenDeleteRowArticles(false); 
        setShowModalSearchDI(false); 
        setEditRowArticles(initialArticlesToSelect); 
        setPostalCodeOriToSelect(initialPostalCodesToSelect);
        setPaymenetTypeSelect(initialPaymentToSelect);
        setVehiclesToSelect(initialVehicleToSelect); 
        setDocumentIdToSelect(initialDocumentIdToSelect);
        setTradenameToSelect(initialDocumentIdToSelect); 
        setDocumentIdOriToSelect(initialDocumentIdToSelect); 
        setTradenameOriToSelect(initialDocumentIdToSelect); 
        setWorkPlaceToSelect(initialWorkPlaceToSelect);
        setFilteredVehicle([]);
        setHighlightedIndexVehicle(-1); 
        setFilteredDocumentId([]);
        setHighlightedIndexDocumentId(-1); 
        setFilteredTradename([]);
        setHighlightedIndexTradename(-1); 
        setFilteredDocumentIdOri([]);
        setHighlightedIndexDocumentIdOri(-1); 
        setFilteredTradenamedOri([]);
        setHighlightedIndexTradenamedOri(-1); 
        setFilteredWorkPlace([]);
        setHighlightedIndexWorkPlace(-1); 
        setFilteredpostalCodeOri([]);
        setHighlightedIndexPostalCodeOri(-1);  
        if (signDispatchedOptTrasCanvas.current) signDispatchedOptTrasCanvas.current.clear();
        if (signDispatchedDestTrasCanvas.current) signDispatchedDestTrasCanvas.current.clear();
        navigate(typeOfList==="1"?"/purchasedelivery":typeOfList==="2"?"/purchasedeliveryended":"/purchasedeliverybegin");
      }
    },
    [
      setFormPurchaseDelivery, 
      setIsLoadingErrorData,
      setErrorsForm,
      setTetxtSearch,  
      setIdCodeDeletePurchaseDelivery,
      setShowModalSearchStores,
      setShowModalSearchVehicles,
      setShowModalSearchStoresAddress,
      setShowModalSearchArticles, 
      setOpenDeleteRowArticles,
      setEditRowArticles,   
      setShowModalSearchDI,
      setPostalCodeOriToSelect,
      setPaymenetTypeSelect,  
      setVehiclesToSelect, 
      setDocumentIdToSelect,
      setTradenameToSelect, 
      setDocumentIdOriToSelect, 
      setTradenameOriToSelect,
      setWorkPlaceToSelect,
      setFilteredVehicle,
      setHighlightedIndexVehicle,
      setFilteredDocumentId, 
      setHighlightedIndexDocumentId,
      setFilteredTradename, 
      setHighlightedIndexTradename,
      setFilteredDocumentIdOri,
      setHighlightedIndexDocumentIdOri,
      setFilteredTradenamedOri,
      setHighlightedIndexTradenamedOri,
      setFilteredWorkPlace,
      setHighlightedIndexWorkPlace,
      setFilteredpostalCodeOri,
      setHighlightedIndexPostalCodeOri,
      showModalPurchasesDeliverySettings,
      navigate,
      typeOfList,
      dispatch,
      DELETE_CODE]
  );
  
  const handleCloseDataEditPurchaseDelivery = () => {
    setFormPurchaseDelivery(formPurchaseDelivery => ({
      ...formPurchaseDelivery,
      linespurchasedelivery: [],
    }));
    setFormPurchaseDelivery(initialStatePurchaseDelivery);
    dispatch(setLoading(false));
    setIsLoadingErrorData(false);
    setErrorsForm({});
    setTetxtSearch("Rel_Trans ");   
    setIdCodeDeletePurchaseDelivery(DELETE_CODE);
    setShowModalSearchStores(false);
    setShowModalSearchVehicles(false);
    setShowModalSearchStoresAddress(false);
    setShowModalSearchArticles(false); 
    setOpenDeleteRowArticles(false); 
    setShowModalSearchDI(false); 
    setEditRowArticles(initialArticlesToSelect); 
    setPostalCodeOriToSelect(initialPostalCodesToSelect);
    setPaymenetTypeSelect(initialPaymentToSelect);
    setVehiclesToSelect(initialVehicleToSelect); 
    setDocumentIdToSelect(initialDocumentIdToSelect);
    setTradenameToSelect(initialDocumentIdToSelect);
    setDocumentIdOriToSelect(initialDocumentIdToSelect); 
    setTradenameOriToSelect(initialDocumentIdToSelect); 
    setFilteredVehicle([]);
    setHighlightedIndexVehicle(-1); 
    setFilteredDocumentId([]);
    setHighlightedIndexDocumentId(-1); 
    setFilteredTradename([]);
    setHighlightedIndexTradename(-1); 
    setFilteredDocumentIdOri([]);
    setHighlightedIndexDocumentIdOri(-1); 
    setFilteredTradenamedOri([]);
    setHighlightedIndexTradenamedOri(-1); 
    setFilteredWorkPlace([]);
    setHighlightedIndexWorkPlace(-1); 
    setFilteredpostalCodeOri([]);
    setHighlightedIndexPostalCodeOri(-1); 
    if (signDispatchedOptTrasCanvas.current) signDispatchedOptTrasCanvas.current.clear();
    if (signDispatchedDestTrasCanvas.current) signDispatchedDestTrasCanvas.current.clear();
    navigate(typeOfList==="1"?"/purchasedelivery":typeOfList==="2"?"/purchasedeliveryended":"/purchasedeliverybegin");
	};
  
  const deleteSignature = (id) => {
    switch (id) {
      case 1:   
        if (signDispatchedOptTrasCanvas.current) signDispatchedOptTrasCanvas.current.clear();
        setFormPurchaseDelivery(formPurchaseDelivery => ({
          ...formPurchaseDelivery,
          signature_dispatched_by: "",
        }));
        break;
      case 2: 
        if (signDispatchedDestTrasCanvas.current) signDispatchedDestTrasCanvas.current.clear();
        setFormPurchaseDelivery(formPurchaseDelivery => ({
          ...formPurchaseDelivery,
          signature_client: "",
        }));
        break;
      default:
        break;
    } 
  }; 

  const drawSignatureCentered = (canvasRef, base64) => {
    if (!canvasRef?.current || !base64) return;
    const canvas = canvasRef.current.getCanvas();
    const ctx = canvas.getContext("2d");
    // 🔒 Forzar tamaño interno fijo
    canvas.width = CANVAS_SIZE;
    canvas.height = CANVAS_SIZE;
    ctx.clearRect(0, 0, CANVAS_SIZE, CANVAS_SIZE);
    const img = new Image();
    img.src = base64;
    img.onload = () => {
      const imgWidth = img.width;
      const imgHeight = img.height;
      const scale = Math.min(
        CANVAS_SIZE / imgWidth,
        CANVAS_SIZE / imgHeight
      );
      const drawWidth = imgWidth * scale;
      const drawHeight = imgHeight * scale;
      const x = (CANVAS_SIZE - drawWidth) / 2;
      const y = (CANVAS_SIZE - drawHeight) / 2;
      ctx.drawImage(img, x, y, drawWidth, drawHeight);
    };
  };

  const drawSignatureCenteredClient = (canvasRef, base64) => {
  if (!canvasRef?.current || !base64) return;
    const canvas = canvasRef.current.getCanvas();
    const ctx = canvas.getContext("2d");
    // 🔒 Forzar tamaño interno fijo
    canvas.width = CLIENT_CANVAS_WIDTH;
    canvas.height = CLIENT_CANVAS_HEIGHT;
    ctx.clearRect(0, 0, CLIENT_CANVAS_WIDTH, CLIENT_CANVAS_HEIGHT);
    const img = new Image();
    img.src = base64;
    img.onload = () => {
      const imgWidth = img.width;
      const imgHeight = img.height;
      const scale = Math.min(
        CLIENT_CANVAS_WIDTH / imgWidth,
        CLIENT_CANVAS_HEIGHT / imgHeight
      );
      const drawWidth = imgWidth * scale;
      const drawHeight = imgHeight * scale;
      const x = (CLIENT_CANVAS_WIDTH - drawWidth) / 2;
      const y = (CLIENT_CANVAS_HEIGHT - drawHeight) / 2;
      ctx.drawImage(img, x, y, drawWidth, drawHeight);
    };
  };

  const drawPredefinedSignature = (imageSrc) => {
    if (!signDispatchedOptTrasCanvas.current) return;
    const canvasRef = signDispatchedOptTrasCanvas.current;
    const canvas = canvasRef.getCanvas();
    const ctx = canvas.getContext("2d");
    canvas.width = CANVAS_SIZE;
    canvas.height = CANVAS_SIZE;
    ctx.clearRect(0, 0, CANVAS_SIZE, CANVAS_SIZE);
    const img = new Image();
    img.src = imageSrc;
    img.onload = () => {
      const imgWidth = img.width;
      const imgHeight = img.height;
      const scale = Math.min(
        CANVAS_SIZE / imgWidth,
        CANVAS_SIZE / imgHeight
      );
      const drawWidth = imgWidth * scale;
      const drawHeight = imgHeight * scale;
      const x = (CANVAS_SIZE - drawWidth) / 2;
      const y = (CANVAS_SIZE - drawHeight) / 2;
      ctx.drawImage(img, x, y, drawWidth, drawHeight);
      const base64 = canvasRef
        .getTrimmedCanvas()
        .toDataURL("image/png");
      setFormPurchaseDelivery(prev => ({
        ...prev,
        signature_dispatched_by: base64
      }));
    };
  };
  
  const predefinedSignaturesArena = [
    signFrancisco,
    signGonzalo,
    signGuillermo,
    signJorge,
    signKirian
  ];

  const predefinedSignaturesBentahor = [
    signBentahor,
    signDiego,
    signMario,
    signRoberto,
    signSantiago
  ];
  // Debounce helper
  const useDebounce = (callback, delay = 300) => {
    const timeoutRef = useRef(null);
    return useCallback((...args) => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        callback(...args);
      }, delay);
    }, [callback, delay]);
  };
  // Dentro del componente
  const debouncedHandleSearchVehicle = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredVehicle([]);
      setHighlightedIndexVehicle(-1);
      return;
    }
    const filtered = vehiclesToSelect
      .filter(vehicle => vehicle && vehicle.licenseplate)
      .filter(vehicle => {
        const licenseplate = vehicle.licenseplate.toUpperCase();
        return licenseplate.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
      setFilteredVehicle(filtered);
      setHighlightedIndexVehicle(0);
  }, 300);
  const handleSelectVehicleFrom = (vehicle) => {
    if (!vehicle) return; // Validación adicional para evitar errores
    setFormPurchaseDelivery(formPurchaseDelivery => ({
      ...formPurchaseDelivery,
      vehiclestore_licenseplate: (vehicle.licenseplate || "") 
    }));
    setFilteredVehicle([]);
    setHighlightedIndexVehicle(-1);
  }; 
  const handleKeyDownVehicleFrom = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredVehicle.length === 0 && formPurchaseDelivery.vehiclestore_licenseplate.trim() === "") {
        setFilteredVehicle(vehiclesToSelect);
        setHighlightedIndexVehicle(0);
      } else {
        setHighlightedIndexVehicle((prevIndex) => {
          const nextIndex = prevIndex < filteredVehicle.length - 1 ? prevIndex + 1 : prevIndex;
          // Desplaza al siguiente elemento
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexVehicle((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        // Desplaza al elemento anterior
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexVehicle >= 0) {
      if (highlightedIndexVehicle >= 0 && highlightedIndexVehicle < filteredVehicle.length) {
        handleSelectVehicleFrom(filteredVehicle[highlightedIndexVehicle]);
      }
    } else if (event.key === "Escape") {
      const isValid = vehiclesToSelect.some((store) => {
        if (!store || !store.licenseplate) return false; 
        const normalizedVehicle = store.licenseplate.toUpperCase().replace(/[.-]/g, "");
        const normalizedInputVehicle = formPurchaseDelivery.vehiclestore_licenseplate.toUpperCase().replace(/[.-]/g, "");
        return normalizedVehicle === normalizedInputVehicle;
      }); 
      if (!isValid) {
        setFormPurchaseDelivery((formPurchaseDelivery) => ({
          ...formPurchaseDelivery,
          vehiclestore_licenseplate: "",
        }));
      } 
      setFilteredVehicle([]);
      setHighlightedIndexVehicle(-1);
    }
  };
  // Dentro del componente
  const debouncedHandleSearchDocumentId = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredDocumentId([]);
      setHighlightedIndexDocumentId(-1);
      return;
    }
    const filtered = documentIdToSelect
      .filter(store => store && store.documentid)
      .filter(store => {
        const documentId = store.documentid.toUpperCase();
        return documentId.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredDocumentId(filtered);
    setHighlightedIndexDocumentId(0);
  }, 300);
  // Manejo de la selección de una tienda
  const handleSelectDocumentId = (store) => {
    if (!store) return; // Validación adicional para evitar errores
    setFormPurchaseDelivery((formPurchaseDelivery) => ({
      ...formPurchaseDelivery,
      rel_trans_documentid: store.documentid || "",
    }));
    setFilteredDocumentId([]);
    setHighlightedIndexDocumentId(-1);
  }; 
  const handleKeyDownDocumentId = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredDocumentId.length === 0 && formPurchaseDelivery.rel_trans_documentid.trim() === "") {
        setFilteredDocumentId(documentIdToSelect);
        setHighlightedIndexDocumentId(0);
      } else {
        setHighlightedIndexDocumentId((prevIndex) => {
          const nextIndex = prevIndex < filteredDocumentId.length - 1 ? prevIndex + 1 : prevIndex;
          // Desplaza al siguiente elemento
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexDocumentId((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        // Desplaza al elemento anterior
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexDocumentId >= 0) {
      if (highlightedIndexDocumentId >= 0 && highlightedIndexDocumentId < filteredDocumentId.length) {
        handleSelectDocumentId(filteredDocumentId[highlightedIndexDocumentId]);
      }
    } else if (event.key === "Escape") {
      const isValid = documentIdToSelect.some((store) => {
        if (!store || !store.documentid) return false; 
        const normalizedStoreId = store.documentid.toUpperCase().replace(/[.-]/g, "");
        const normalizedInputId = formPurchaseDelivery.rel_trans_documentid.toUpperCase();
        return normalizedStoreId === normalizedInputId;
      }); 
      if (!isValid) {
        setFormPurchaseDelivery((formPurchaseDelivery) => ({
          ...formPurchaseDelivery,
          rel_trans_documentid: "",
        }));
      } 
      setFilteredDocumentId([]);
      setHighlightedIndexDocumentId(-1);
    }
  }; 
  // Dentro del componente
  const debouncedHandleSearchTradename= useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredTradename([]);
      setHighlightedIndexTradename(-1);
      return;
    }
    const filtered = tradenameToSelect
      .filter(store => store && store.tradename)
      .filter(store => {
        const tradename = store.tradename.toUpperCase();
        return tradename.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
      setFilteredTradename(filtered);
      setHighlightedIndexTradename(0);
  }, 300);
  const handleSelectTradeName = (store) => {
    if (!store) return; // Validación adicional para evitar errores
    setFormPurchaseDelivery((formPurchaseDelivery) => ({
      ...formPurchaseDelivery,
      rel_trans_tradename: store.tradename || "",
      rel_trans_documentid: store.documentid || formPurchaseDelivery.rel_trans_documentid,
      
    }));
    setFilteredTradename([]);
    setHighlightedIndexTradename(-1);
  }; 
  const handleKeyDownTradename = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredTradename.length === 0 && formPurchaseDelivery.rel_trans_tradename.trim() === "") {
        setFilteredTradename(tradenameToSelect);
        setHighlightedIndexTradename(0);
      } else {
        setHighlightedIndexTradename((prevIndex) => {
          const nextIndex = prevIndex < filteredTradename.length - 1 ? prevIndex + 1 : prevIndex;
          // Desplaza al siguiente elemento
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexTradename((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        // Desplaza al elemento anterior
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexTradename >= 0) {
      if (highlightedIndexTradename >= 0 && highlightedIndexTradename < filteredTradename.length) {
        handleSelectTradeName(filteredTradename[highlightedIndexTradename]);
      }
    } else if (event.key === "Escape") {
      const isValid = tradenameToSelect.some((store) => {
        if (!store || !store.tradename) return false; 
        const normalizedTradeName = store.tradename.toUpperCase();
        const normalizedInputTradeName = formPurchaseDelivery.rel_trans_tradename.toUpperCase();
        return normalizedTradeName === normalizedInputTradeName;
      }); 
      if (!isValid) {
        setFormPurchaseDelivery((formPurchaseDelivery) => ({
          ...formPurchaseDelivery,
          rel_trans_tradename: "",
        }));
      } 
      setFilteredTradename([]);
      setHighlightedIndexTradename(-1);
    }
  }; 

  // Dentro del componente
  const debouncedHandleSearchDocumentIdOri = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredDocumentIdOri([]);
      setHighlightedIndexDocumentIdOri(-1);
      return;
    }
    const filtered = documentIdOriToSelect
      .filter(store => store && store.documentid)
      .filter(store => {
        const documentId = store.documentid.toUpperCase();
        return documentId.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
      setFilteredDocumentIdOri(filtered);
      setHighlightedIndexDocumentIdOri(0);
  }, 300);
  const handleSelectDocumentIdOri = (store) => {
    if (!store) return; // Validación adicional para evitar errores
    setFormPurchaseDelivery((formPurchaseDelivery) => ({
      ...formPurchaseDelivery,
      ori_tras_documentid: store.documentid || "",
    }));
    setFilteredDocumentIdOri([]);
    setHighlightedIndexDocumentIdOri(-1);
  }; 
  const handleKeyDownDocumentIdOri = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredDocumentIdOri.length === 0 && formPurchaseDelivery.ori_tras_documentid.trim() === "") {
        setFilteredDocumentIdOri(documentIdOriToSelect);
        setHighlightedIndexDocumentIdOri(0);
      } else {
        setHighlightedIndexDocumentIdOri((prevIndex) => {
          const nextIndex = prevIndex < filteredDocumentIdOri.length - 1 ? prevIndex + 1 : prevIndex;
          // Desplaza al siguiente elemento
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexDocumentIdOri((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        // Desplaza al elemento anterior
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexDocumentIdOri >= 0) {
      if (highlightedIndexDocumentIdOri >= 0 && highlightedIndexDocumentIdOri < filteredDocumentIdOri.length) {
        handleSelectDocumentIdOri(filteredDocumentIdOri[highlightedIndexDocumentIdOri]);
      }
    } else if (event.key === "Escape") {
      const isValid = documentIdOriToSelect.some((store) => {
        if (!store || !store.documentid) return false; 
        const normalizedStoreId = store.documentid.toUpperCase().replace(/[.-]/g, "");
        const normalizedInputId = formPurchaseDelivery.ori_tras_documentid.toUpperCase();
        return normalizedStoreId === normalizedInputId;
      }); 
      if (!isValid) {
        setFormPurchaseDelivery((formPurchaseDelivery) => ({
          ...formPurchaseDelivery,
          ori_tras_documentid: "",
        }));
      } 
      setFilteredTradenamedOri([]);
      setHighlightedIndexDocumentIdOri(-1);
    }
  };

  // Dentro del componente
  const debouncedHandleSearchTradenameOri= useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredTradenamedOri([]);
      setHighlightedIndexTradenamedOri(-1);
      return;
    }
    const filtered = tradenameOriToSelect
      .filter(store => store && store.tradename)
      .filter(store => {
        const tradename = store.tradename.toUpperCase();
        return tradename.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
      setFilteredTradenamedOri(filtered);
      setHighlightedIndexTradenamedOri(0);
  }, 300);
  // Manejo de la selección de una tienda
  const handleSelectTradeNameOri = (store) => {
    if (!store) return; // Validación adicional para evitar errores
    setFormPurchaseDelivery((formPurchaseDelivery) => ({
      ...formPurchaseDelivery,
      ori_tras_tradename: store.tradename || "",
      ori_tras_documentid: store.documentid || formPurchaseDelivery.ori_tras_documentid,
      
    }));
    setFilteredTradenamedOri([]);
    setHighlightedIndexTradenamedOri(-1);
  }; 
  const handleKeyDownTradenameOri = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredTradenamedOri.length === 0 && formPurchaseDelivery.ori_tras_tradename.trim() === "") {
        setFilteredTradenamedOri(tradenameOriToSelect);
        setHighlightedIndexTradenamedOri(0);
      } else {
        setHighlightedIndexTradenamedOri((prevIndex) => {
          const nextIndex = prevIndex < filteredTradenamedOri.length - 1 ? prevIndex + 1 : prevIndex;
          // Desplaza al siguiente elemento
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexTradenamedOri((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        // Desplaza al elemento anterior
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexTradenamedOri >= 0) {
      if (highlightedIndexTradenamedOri >= 0 && highlightedIndexTradenamedOri < filteredTradenamedOri.length) {
        handleSelectTradeNameOri(filteredTradenamedOri[highlightedIndexTradenamedOri]);
      }
    } else if (event.key === "Escape") {
      const isValid = tradenameOriToSelect.some((store) => {
        if (!store || !store.tradename) return false; 
        const normalizedTradeName = store.tradename.toUpperCase();
        const normalizedInputTradeName = formPurchaseDelivery.ori_tras_tradename.toUpperCase();
        return normalizedTradeName === normalizedInputTradeName;
      }); 
      if (!isValid) {
        setFormPurchaseDelivery((formPurchaseDelivery) => ({
          ...formPurchaseDelivery,
          ori_tras_tradename: "",
        }));
      } 
      setFilteredTradenamedOri([]);
      setHighlightedIndexTradenamedOri(-1);
    }
  };
  // Dentro del componente
  const debouncedHandleSearchWorkPlace= useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredWorkPlace([]);
      setHighlightedIndexWorkPlace(-1);
      return;
    }
    const filtered = workPlaceToSelect
      .filter(store => store && store.workplace)
      .filter(store => {
        const workplace = store.workplace.toUpperCase();
        return workplace.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
      setFilteredWorkPlace(filtered);
      setHighlightedIndexWorkPlace(0);
  }, 300);
  const handleSelectWorkPlace = (store) => {
    if (!store) return; // Validación adicional para evitar errores
    setFormPurchaseDelivery((formPurchaseDelivery) => ({
      ...formPurchaseDelivery,
      ori_tras_workplace: store.workplace || ""
      
    }));
    setFilteredWorkPlace([]);
    setHighlightedIndexWorkPlace(-1);
  }; 

  const handleKeyDownWorkPlace = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredWorkPlace.length === 0 && formPurchaseDelivery.ori_tras_workplace.trim() === "") {
        setFilteredWorkPlace(workPlaceToSelect);
        setHighlightedIndexWorkPlace(0);
      } else {
        setHighlightedIndexWorkPlace((prevIndex) => {
          const nextIndex = prevIndex < filteredWorkPlace.length - 1 ? prevIndex + 1 : prevIndex;
          // Desplaza al siguiente elemento
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexWorkPlace((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        // Desplaza al elemento anterior
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexWorkPlace >= 0) {
      if (highlightedIndexWorkPlace >= 0 && highlightedIndexWorkPlace < filteredWorkPlace.length) {
        handleSelectWorkPlace(filteredWorkPlace[highlightedIndexWorkPlace]);
      }
    } else if (event.key === "Escape") {
      const isValid = workPlaceToSelect.some((store) => {
        if (!store || !store.workplace) return false; 
        const normalizedWorkPlace = store.workplace.toUpperCase();
        const normalizedInputWorkPlace = formPurchaseDelivery.ori_tras_workplace.toUpperCase();
        return normalizedWorkPlace === normalizedInputWorkPlace;
      }); 
      if (!isValid) {
        setFormPurchaseDelivery((formPurchaseDelivery) => ({
          ...formPurchaseDelivery,
          ori_tras_workplace: "",
        }));
      } 
      setFilteredWorkPlace([]);
      setHighlightedIndexWorkPlace(-1);
    }
  };

  // Dentro del componente
  const debouncedHandleSearchPostalCode= useDebounce((searchValue) => {
      const upperValue = searchValue.toUpperCase();
      if (upperValue.trim() === "") {
          setFilteredpostalCodeOri([]);
          setHighlightedIndexPostalCodeOri(-1);
      return;
      }
      const filtered = postalCodeOriToSelect
      .filter(postal => postal && postal.postalcode)
      .filter(postal => {
          const postalcode = postal.postalcode.toUpperCase();
          return postalcode.startsWith(upperValue);
      })
      .slice(0, 20); // limitar resultados
      setFilteredpostalCodeOri(filtered);
      setHighlightedIndexPostalCodeOri(0);
  }, 300); 
  const handleSelectPostalCodeOri = (postal) => {
      if (!postal) return; // Validación adicional para evitar errores
      setFormPurchaseDelivery((formPurchaseDelivery) => ({
          ...formPurchaseDelivery,
          ori_tras_postalcode_id: postal.id || Number(DEFAULTPOSTALCODE_ID),
          ori_tras_postalcode_code: postal.postalcode ||  DEFAULTPOSTALCODE_CODE,
          ori_tras_postalcode_name: postal.name || DEFAULTPOSTALCODE_NAME,
          ori_tras_province_id: postal.province_id || Number(DEFAULTPROVINCE),
          ori_tras_province_name: postal.province_name || DEFAULTPROVINCE_NAME
      }));
      setFilteredpostalCodeOri([]);
      setHighlightedIndexPostalCodeOri(-1);
  }; 
  const handleKeyDownDPostalCodeOri = (event) => {
      if (event.key === "ArrowDown") {
      if (filteredpostalCodeOri.length === 0 && formPurchaseDelivery.ori_tras_postalcode_code.trim() === "") {
          setHighlightedIndexPostalCodeOri(postalCodeOriToSelect);
          setHighlightedIndexPostalCodeOri(0);
      } else {
          setHighlightedIndexPostalCodeOri((prevIndex) => {
          const nextIndex = prevIndex < filteredpostalCodeOri.length - 1 ? prevIndex + 1 : prevIndex;
          // Desplaza al siguiente elemento
          scrollToElement(nextIndex);
          return nextIndex;
          });
      }
      } else if (event.key === "ArrowUp") {
      setHighlightedIndexPostalCodeOri((prevIndex) => {
          const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
          // Desplaza al elemento anterior
          scrollToElement(prevIndexValid);
          return prevIndexValid;
      });
      } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexPostalCodeOri >= 0) {
          if (highlightedIndexPostalCodeOri >= 0 && highlightedIndexPostalCodeOri < filteredpostalCodeOri.length) {
              handleSelectPostalCodeOri(filteredpostalCodeOri[highlightedIndexPostalCodeOri]);
          }
      } else if (event.key === "Escape") {
      const isValid = postalCodeOriToSelect.some((postal) => {
          if (!postal || !postal.postalcode) return false; 
          const normalizedPostalCodeId = postal.postalcode.toUpperCase().replace(/[.-]/g, "");
          const normalizedInputId = formPurchaseDelivery.ori_tras_postalcode_code.toUpperCase();
          return normalizedPostalCodeId === normalizedInputId;
      }); 
      if (!isValid) { 
          setFormPurchaseDelivery((formPurchaseDelivery) => ({
              ...formPurchaseDelivery,
              ori_tras_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
              ori_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
              ori_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
              ori_tras_province_id: Number(DEFAULTPROVINCE),
              ori_tras_province_name: DEFAULTPROVINCE_NAME
          }));
      } 
      setFilteredpostalCodeOri([]);
      setHighlightedIndexPostalCodeOri(-1);
      }
  };
    
  // Función para desplazar el contenedor
  const scrollToElement = (index) => {
    const dropdown = document.querySelector(".dropdown-class"); // Cambia por tu clase/ID
    const item = dropdown?.children[index];
    if (item) {
      item.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  };

 const handleBlur = useCallback((event) => {
     if (!event || !event.currentTarget) return;
     // Asegúrate de que no se cierra si haces clic en un elemento de la lista
     if (!event.currentTarget.contains(event.relatedTarget)) {
      setFilteredVehicle([]);
      setHighlightedIndexVehicle(-1);
      setFilteredDocumentId([]);
      setHighlightedIndexDocumentId(-1);
      setFilteredTradename([]);
      setHighlightedIndexTradename(-1);
      setFilteredDocumentIdOri([]);
      setHighlightedIndexDocumentIdOri(-1);
      setFilteredTradenamedOri([]);
      setHighlightedIndexTradenamedOri(-1);
      setFilteredWorkPlace([]);
      setHighlightedIndexWorkPlace(-1);
      setFilteredpostalCodeOri([]);
      setHighlightedIndexPostalCodeOri(-1);
    }
  }, []);
  
  const handleChangeDataEditPurchaseDelivery = (e) => {
    const { name, value } = e.target;
    setFormPurchaseDelivery(formPurchaseDelivery => ({
      ...formPurchaseDelivery,
      [name]: value,
    }));
  };

  const handleBlurDataEditPurchaseDelivery = (e) => {
    handleChangeDataEditPurchaseDelivery(e);
    setErrorsForm(validatePurchaseDelivery());
  }; 

  const handleBlurSelectDate = (e) => {
    handleChangeSelectDate(e);
    setErrorsForm(validatePurchaseDelivery());
  };

  const handleChangeSelectDate = (event) => {
    setFormPurchaseDelivery(formPurchaseDelivery => ({
      ...formPurchaseDelivery,
      datepurchase: event!==null?new Date(event):null
    }));
  };

  const handleBlurTotalWeightNeto = (value) => {
    handleChangeTotalWeightNeto(value);
  };

  const handleChangeTotalWeightNeto = (value) => {
    let newValue=value!==null?Number((value.toLocaleString()).replaceAll(",","").replaceAll(" Tn","").replaceAll("kg","").replaceAll("€","").replaceAll("%","")):0;
    setFormPurchaseDelivery(formPurchaseDelivery => ({
      ...formPurchaseDelivery,
      totalWeigthNeto: newValue
    }));
  };

  const searchStoreRelTrans = (event) => {
    setTetxtSearch("Rel_Trans")
    setShowModalSearchStores(true);
  };

  const deleteDataStoreAddressOriTras = (event) => {
    setFormPurchaseDelivery(formPurchaseDelivery => ({
      ...formPurchaseDelivery,
      ori_tras_nima: "",
      ori_tras_pygr: "",
      ori_tras_grnp:"",
      ori_tras_opt: 0,
      ori_tras_roadtype_id: Number(DEFAULTROADTYE),
      ori_tras_street: "",
      ori_tras_country_id: Number(DEFAULTCOUNTRY),
      ori_tras_country_name:DEFAULTCOUNTRY_NAME,
      ori_tras_province_id: Number(DEFAULTPROVINCE),
      ori_tras_province_name:DEFAULTPROVINCE_NAME,
      ori_tras_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
      ori_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
      ori_tras_postalcode_name: DEFAULTPOSTALCODE_NAME

    }));  
    setErrorsForm(validatePurchaseDelivery());
  };

  const searchStoreAddress = (event) => {
    setShowModalSearchStoresAddress(true);
  };

  const deleteDataStoreRelTrans = (event) => {
    setFormPurchaseDelivery(formPurchaseDelivery => ({
      ...formPurchaseDelivery,
      rel_trans_store_id: 0,
      rel_trans_documnettype_id: Number(DEFAULTTYPEOFDOCUMENT),
      rel_trans_documnettype_name: "",
      rel_trans_documentid: "",
      rel_trans_tradename: "",
      rel_trans_name: "",
      rel_trans_contacperson: "",
      rel_trans_nima: "",
      rel_trans_pygr: "",
      rel_trans_grnp:"",
      rel_trans_opt: 0,
      rel_trans_roadtype_id: Number(DEFAULTROADTYE),
      rel_trans_street: "",
      rel_trans_country_id: Number(DEFAULTCOUNTRY),
      rel_trans_country_name:DEFAULTCOUNTRY_NAME,
      rel_trans_province_id: Number(DEFAULTPROVINCE),
      rel_trans_province_name:DEFAULTPROVINCE_NAME,
      rel_trans_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
      rel_trans_postalcode_code:  DEFAULTPOSTALCODE_CODE,
      rel_trans_postalcode_name: DEFAULTPOSTALCODE_NAME,
    }));  
    setTrasporterId(0);
    setErrorsForm(validatePurchaseDelivery());
  };

  const searchVehicles = (event) => { 
    setShowModalSearchVehicles(true);
  };
 
  const deleteDataVehicles = (event) => {
    setFormPurchaseDelivery(formPurchaseDelivery => ({
      ...formPurchaseDelivery,
      vehiclestore_id:0,
      vehiclestore_licenseplate: "",
      vehiclestore_defaultdriver:"",
      vehiclestore_store_id:0
    })); 
    setFilteredVehicle([]);
    setHighlightedIndexVehicle(-1); 
    setErrorsForm(validatePurchaseDelivery());
  };

  const deleteDataStoreOriTras = (event) => {
    setFormPurchaseDelivery(formPurchaseDelivery => ({
      ...formPurchaseDelivery,
      ori_tras_store_id: 0,
      ori_tras_documnettype_id: Number(DEFAULTTYPEOFDOCUMENT),
      ori_tras_documnettype_name: "",
      ori_tras_documentid: "",
      ori_tras_tradename: "",
      ori_tras_name: "",
      ori_tras_contacperson: "",
      ori_tras_nima: "",
      ori_tras_pygr: "",
      ori_tras_grnp:"",
      ori_tras_opt: 0,
      ori_tras_workplace: "",
      ori_tras_roadtype_id: Number(DEFAULTROADTYE),
      ori_tras_street: "",
      ori_tras_country_id: Number(DEFAULTCOUNTRY),
      ori_tras_country_name:DEFAULTCOUNTRY_NAME,
      ori_tras_province_id: Number(DEFAULTPROVINCE),
      ori_tras_province_name:DEFAULTPROVINCE_NAME,
      ori_tras_postalcode_id: Number(DEFAULTPOSTALCODE_ID),
      ori_tras_postalcode_code: DEFAULTPOSTALCODE_CODE,
      ori_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
      ori_tras_email: "",
      payment_id:2
    }));  
    setOritrasId(0);
    setErrorsForm(validatePurchaseDelivery());
  };

  const searchStoreOriTras = (event) => {
    setTetxtSearch("Ori_Tras")
    setShowModalSearchStores(true);
  };

  const handleCancelDeleteRow = () => { 
    setEditRowArticles(initialArticlesToSelect); 
    dispatch(setLoading(false));  
    setIsLoadingErrorData(false);
    setIdCodeDeletePurchaseDelivery(DELETE_CODE);
    setOpenDeleteRowArticles(false);
  };

  const handleChangeDeleteRow = (e) => {
    const value  = e.target.value;
    setIdCodeDeletePurchaseDelivery(value);
  };

  const handleCloseDeleteRow = (e) => {
    e.preventDefault();
    if (idCodeDeletePurchaseDelivery!==DELETE_CODE){
      dispatch(warningErrorAction(t('Text_InvalidCode')));
    } else {
      
      let indexDelete=formPurchaseDelivery.linespurchasedelivery.findIndex(((item) => item.indexrowarticle === editRowArticles.indexrowarticle));
      if ( indexDelete !== -1 ) {
        formPurchaseDelivery.linespurchasedelivery.splice( indexDelete, 1 );
      }
      setFormPurchaseDelivery(formPurchaseDelivery => ({
        ...formPurchaseDelivery,
      })) 
      let totalNeto=0; 
      formPurchaseDelivery.linespurchasedelivery.map((item)=>{
        return totalNeto+=item.total;
      });
      setFormPurchaseDelivery(formPurchaseDelivery => ({
        ...formPurchaseDelivery,
        totalNetoPurchasedelivery:totalNeto
       }));
      setIdCodeDeletePurchaseDelivery(DELETE_CODE);
      setOpenDeleteRowArticles(false);
    }
  };
   
  const selectArticle = (post) => {
    
    let articleToAdd={
      "id":"",
      "indexrowarticle":formPurchaseDelivery.linespurchasedelivery.length>0?formPurchaseDelivery.linespurchasedelivery[formPurchaseDelivery.linespurchasedelivery.length-1].indexrowarticle+1:1,
      "purchase_id":formPurchaseDelivery.id,
      "article_id":post.button_article_id,
      "article_code":post.button_article_code,
      "article_namees":post.button_article_namees,
      "article_nameen":post.button_article_nameen,
      "datepurchase":formPurchaseDelivery.datepurchase,
      "estimatedprice":post.button_article_estimatedprice,
      "amount":0,
      "discount":0,
      "tax":post.button_article_tax,
      "taxincluded": post.button_article_taxincluded, 
      "total": 0 ,
      "ticketweight":post.button_article_ticketweight,
      "formdi_id":0,
      "ownformdi_id":0
      
    }
    formPurchaseDelivery.linespurchasedelivery.push(articleToAdd);
    setFormPurchaseDelivery(formPurchaseDelivery => ({
      ...formPurchaseDelivery,
      totalpurchasedelivery:0,
      totaldiscountpurchasedelivery:0,
      totaltaxespurchasedelivery:0 
    })); 
    setFormPurchaseDelivery(formPurchaseDelivery => ({
      ...formPurchaseDelivery
    }));
  };

  const withValueCap3 = (inputObj) => {
    const { value } = inputObj;
    if (value <= 10000000000) return true;
    return false;
  };
 
  const handleConfirmFetchDataEditOurchase = (dataToSend) => {  
    const fetchData = async () => { 
      try {
        const getData = (id !== "0" && id !== 0)
          ? await helpHttp().put(ENDPOINT, `purchasedelivery/updatepurchasedelivery`, token, dataToSend)
          : await helpHttp().post(ENDPOINT, `purchasedelivery/savepurchasedelivery`, token, dataToSend);
        if (getData.status === "OK") {
          dispatch(successErrorAction(t('Text_SaveData')));
        } else {
          dispatch(warningErrorAction(t(getData.cause)));
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
    fetchData();
    handleCloseDataEditPurchaseDelivery();
    return () => {};
  };
   

  const handleSubmitDataEditPurchaseEdit = () => {
    const errors = validatePurchaseDelivery();
    setErrorsForm(errors);
    if ((Object.keys(errors).length === 0) 
        && formPurchaseDelivery.linespurchasedelivery!==undefined  
        && formPurchaseDelivery.linespurchasedelivery.length>0 ) {
      
      let signatureOpt_tras = formPurchaseDelivery.signature_dispatched_by;
      let signatureDest_tras = formPurchaseDelivery.signature_client;
      if (signDispatchedOptTrasCanvas.current && !signDispatchedOptTrasCanvas.current.isEmpty()) {
        signatureOpt_tras = signDispatchedOptTrasCanvas.current.getTrimmedCanvas().toDataURL("image/png");
      }
      if (signDispatchedDestTrasCanvas.current && !signDispatchedDestTrasCanvas.current.isEmpty()) {
        signatureDest_tras = signDispatchedDestTrasCanvas.current.getTrimmedCanvas().toDataURL("image/png");
      }
       const formToSend = {
        ...formPurchaseDelivery,
        signature_dispatched_by: signatureOpt_tras,
        signature_client: signatureDest_tras 
      };
      setFormPurchaseDelivery(formPurchaseDelivery => ({
        ...formPurchaseDelivery,
        signature_dispatched_by: signatureOpt_tras,
        signature_client: signatureDest_tras 
      }));
      handleConfirmFetchDataEditOurchase(formToSend);  
    } else {
      if (formPurchaseDelivery.linespurchasedelivery===undefined  
        || formPurchaseDelivery.linespurchasedelivery.length===0 ){
          dispatch(warningErrorAction(t('Text_FieldArticlesRequired')));
      }else{
        dispatch(warningErrorAction(t('Text_IncorrectData')));      
      }
    }
  };

  const validatePurchaseDelivery = () => {
    let errorsForm = {};
    let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
    
    if (regexInvalidCharacters.test(formPurchaseDelivery.ownnumberpurchase)) {
      errorsForm.ownnumberpurchase = 'Text_TextNoValid';
    }

    if (formPurchaseDelivery.subownnumberpurchase!=="" & !regexNumber.test(formPurchaseDelivery.subownnumberpurchase)) {
      formPurchaseDelivery.subownnumberpurchase = 'Text_TextNoNumber';
    }

    if (regexInvalidCharacters.test(formPurchaseDelivery.rel_trans_documentid)) {
      errorsForm.rel_trans_documentid = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formPurchaseDelivery.vehiclestore_licenseplate)) {
      errorsForm.vehiclestore_licenseplate = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formPurchaseDelivery.rel_trans_tradename)) {
      errorsForm.rel_trans_tradename = 'Text_TextNoValid';
    }  
    if (regexInvalidCharacters.test(formPurchaseDelivery.ori_tras_nima)) {
      errorsForm.ori_tras_nima = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formPurchaseDelivery.ori_tras_pygr)) {
      errorsForm.ori_tras_pygr = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formPurchaseDelivery.ori_tras_grnp)) {
      errorsForm.ori_tras_grnp = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formPurchaseDelivery.ori_tras_workplace)) {
      errorsForm.ori_tras_workplace = 'Text_TextNoValid';
    }  
    if (regexInvalidCharacters.test(formPurchaseDelivery.ori_tras_street)) {
      errorsForm.ori_tras_street = 'Text_TextNoValid';
    }

    if (regexInvalidCharacters.test(formPurchaseDelivery.ori_tras_email)) {
      errorsForm.ori_tras_email = 'Text_TextNoValid';
    } 

    if (regexInvalidCharacters.test(formPurchaseDelivery.observations)) {
      errorsForm.observations = 'Text_TextNoValid';
    } 
    return errorsForm;
  };
  
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  useEffect(() => {
    let isMounted = true;
    const fetchExistNumberDocumentRelTrans = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`purchasedelivery/getstorebynumberdocument/`,token,formPurchaseDelivery.rel_trans_documentid.replace(/[.\-/\\|]/g, ""));
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          if (getData>0 && getData!==formPurchaseDelivery.rel_trans_documentid){
            fetchStoreNumberDocumentRelTrans();
          }
        }
      } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    const fetchStoreNumberDocumentRelTrans = async () => {
      try {
          const getData = await helpHttp().get5(ENDPOINT,`purchasedelivery/getstorebynumberdocumentpriority`,token,formPurchaseDelivery.rel_trans_documentid.replace(/[.\-/\\|]/g, ""),6);
          if (getData.err) {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else if (isMounted) {
              if (getData!==undefined && getData!==null && getData!==""){
                setTrasporterId(getData.rel_trans_store_id);
                setFormPurchaseDelivery(formPurchaseDelivery => ({
                      ...formPurchaseDelivery,
                      rel_trans_store_id: getData.rel_trans_store_id,
                      rel_trans_documnettype_id: (getData.rel_trans_documnettype_id===undefined 
                                              || getData.rel_trans_documnettype_id===null  
                                              || getData.rel_trans_documnettype_id===""
                                              || getData.rel_trans_documnettype_id==="0"
                                              || getData.rel_trans_documnettype_id===0)?
                                              Number(DEFAULTTYPEOFDOCUMENT):getData.rel_trans_documnettype_id,
                      rel_trans_documentid: getData.rel_trans_documentid,
                      rel_trans_documnettype_name: getData.rel_trans_documnettype_name,
                      rel_trans_tradename: getData.rel_trans_tradename,
                      rel_trans_name: getData.rel_trans_name,
                      rel_trans_contacperson: getData.rel_trans_contacperson,
                      rel_trans_nima: (formPurchaseDelivery.rel_trans_nima===undefined 
                        ||formPurchaseDelivery.rel_trans_nima===null
                        ||formPurchaseDelivery.rel_trans_nima==="")
                        ?getData.rel_trans_nima:formPurchaseDelivery.rel_trans_nima,
                      rel_trans_pygr: (formPurchaseDelivery.rel_trans_pygr===undefined 
                        ||formPurchaseDelivery.rel_trans_pygr===null
                        ||formPurchaseDelivery.rel_trans_pygr==="")
                        ?getData.rel_trans_pygr:formPurchaseDelivery.rel_trans_pygr,
                      rel_trans_grnp: (formPurchaseDelivery.rel_trans_grnp===undefined 
                          ||formPurchaseDelivery.rel_trans_grnp===null
                          ||formPurchaseDelivery.rel_trans_grnp==="")
                          ?getData.rel_trans_grnp:formPurchaseDelivery.rel_trans_grnp,
                      rel_trans_opt: (getData.rel_trans_opt===undefined 
                            || getData.rel_trans_opt===null  
                            || getData.rel_trans_opt===""
                            || getData.rel_trans_opt==="0"
                            || getData.rel_trans_opt===0)?
                            0:getData.rel_trans_opt, 
                      rel_trans_roadtype_id: (getData.rel_trans_roadtype_id===undefined 
                            || getData.rel_trans_roadtype_id===null  
                            || getData.rel_trans_roadtype_id===""
                            || getData.rel_trans_roadtype_id==="0"
                            || getData.rel_trans_roadtype_id===0)?
                            Number(DEFAULTTYPEOFDOCUMENT):getData.rel_trans_roadtype_id,
                      rel_trans_street: getData.rel_trans_street,
                      rel_trans_country_id: (getData.rel_trans_country_id===undefined 
                            || getData.rel_trans_country_id===null  
                            || getData.rel_trans_country_id===""
                            || getData.rel_trans_country_id==="0"
                            || getData.rel_trans_country_id===0)?
                            Number(DEFAULTCOUNTRY):getData.rel_trans_country_id,
                      rel_trans_country_name: (getData.rel_trans_country_name===undefined 
                            || getData.rel_trans_country_name===null  
                            || getData.rel_trans_country_name==="" )?
                            DEFAULTCOUNTRY_NAME:getData.rel_trans_country_name,
                      rel_trans_province_id: (getData.rel_trans_province_id===undefined 
                            || getData.rel_trans_province_id===null  
                            || getData.rel_trans_province_id===""
                            || getData.rel_trans_province_id==="0"
                            || getData.rel_trans_province_id===0)?
                            Number(DEFAULTPROVINCE):getData.rel_trans_province_id,
                      rel_trans_province_name: (getData.rel_trans_province_name===undefined 
                            || getData.rel_trans_province_name===null  
                            || getData.rel_trans_province_name==="" )?
                            DEFAULTPROVINCE_NAME:getData.rel_trans_province_name, 
                      rel_trans_postalcode_id: (getData.rel_trans_postalcode_id===undefined 
                            || getData.rel_trans_postalcode_id===null  
                            || getData.rel_trans_postalcode_id===""
                            || getData.rel_trans_postalcode_id==="0"
                            || getData.rel_trans_postalcode_id===0)?
                            Number(DEFAULTPOSTALCODE_ID):getData.rel_trans_postalcode_id,
                      rel_trans_postalcode_code: (getData.rel_trans_postalcode_code===undefined 
                            || getData.rel_trans_postalcode_code===null  
                            || getData.rel_trans_postalcode_code==="" )?
                              DEFAULTPOSTALCODE_CODE:getData.rel_trans_postalcode_code,
                      rel_trans_postalcode_name:   (getData.rel_trans_postalcode_name===undefined 
                            || getData.rel_trans_postalcode_name===null  
                            || getData.rel_trans_postalcode_name==="" )?
                                DEFAULTPOSTALCODE_NAME:getData.rel_trans_postalcode_name
                  }));
              }  
          }         
        } catch (error) {
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
    };
    if (formPurchaseDelivery.rel_trans_documentid && formPurchaseDelivery.rel_trans_documentid.replace(/[.\-/\\|]/g, "").trim()!==""){
      fetchExistNumberDocumentRelTrans();
    } 
    return () => { isMounted = false };
  }, [t,token,dispatch,formPurchaseDelivery.rel_trans_documentid,errorsForm,DEFAULTCOUNTRY,DEFAULTPROVINCE,setTrasporterId,
    DEFAULTCOUNTRY_NAME,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPOSTALCODE_NAME,DEFAULTPROVINCE_NAME,DEFAULTTYPEOFDOCUMENT,setFormPurchaseDelivery]);
  
  useEffect(() => {
    let isMounted = true;
    const fetchExistLicensePlate = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`purchasedelivery/getexistvehicleylicenseplate/`,token,formPurchaseDelivery.vehiclestore_licenseplate.replace(/[.\-/\\|]/g, ""));
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          if (getData>0 && getData!==formPurchaseDelivery.licenseplate){
            fetchLicensePlate();
          }
        }
      } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    const fetchLicensePlate = async () => {
      try {
          const getData = await helpHttp().get2(ENDPOINT,`purchasedelivery/getvehiclebylicenseplate/`,token,formPurchaseDelivery.vehiclestore_licenseplate.replace(/[.\-/\\|]/g, ""));
          if (getData.err) {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else if (isMounted) {
              if (getData!==undefined && getData!==null && getData!==""){
                setFormPurchaseDelivery(formPurchaseDelivery => ({
                  ...formPurchaseDelivery,
                  vehiclestore_id: getData.id,
                  vehiclestore_store_id: (getData.store_id===undefined 
                                        || getData.store_id===null  
                                        || getData.store_id===""
                                        || getData.store_id==="0"
                                        || getData.store_id===0)?
                                        0:getData.store_id,
                  vehiclestore_defaultdriver: getData.defaultdriver
              }));
              if (formPurchaseDelivery.rel_trans_documentid===undefined || formPurchaseDelivery.rel_trans_documentid===null || formPurchaseDelivery.rel_trans_documentid==="" ){
                if (formPurchaseDelivery.rel_trans_tradename===undefined || formPurchaseDelivery.rel_trans_tradename===null || formPurchaseDelivery.rel_trans_tradename===""){
                  setFormPurchaseDelivery(formPurchaseDelivery => ({
                    ...formPurchaseDelivery,
                    rel_trans_documentid: getData.store_documentid 

                  }));
                }
              }  
            }
          }         
      } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 
    if (formPurchaseDelivery.vehiclestore_licenseplate && formPurchaseDelivery.vehiclestore_licenseplate.replace(/[.\-/\\|]/g, "").trim()!==""){
      fetchExistLicensePlate();
    } 
    return () => { isMounted = false };
  }, [t,token,dispatch,formPurchaseDelivery.vehiclestore_licenseplate,formPurchaseDelivery.rel_trans_documentid,formPurchaseDelivery.rel_trans_tradename,errorsForm,formPurchaseDelivery.licenseplate,
    DEFAULTCOUNTRY_NAME,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPOSTALCODE_NAME,DEFAULTPROVINCE_NAME,DEFAULTTYPEOFDOCUMENT,setFormPurchaseDelivery]);
 
  useEffect(() => {
    let isMounted = true;
    const fetchExistNumberDocumentOriTras = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`purchasedelivery/getstorebynumberdocument/`,token,formPurchaseDelivery.ori_tras_documentid.replace(/[.\-/\\|]/g, ""));
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          if (getData>0 && getData!==formPurchaseDelivery.ori_tras_documentid){
            fetchStoreNumberDocumentOriTras();
          }
        }
      } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    const fetchStoreNumberDocumentOriTras = async () => {
      try {
          const getData = await helpHttp().get5(ENDPOINT,`purchasedelivery/getstorebynumberdocumentpriority`,token,formPurchaseDelivery.ori_tras_documentid.replace(/[.\-/\\|]/g, ""),2);
          if (getData.err) {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else if (isMounted) {
              if (getData!==undefined && getData!==null && getData!=="" && getData!=="0" && getData!==0  && getData.rel_trans_store_id!==formPurchaseDelivery.ori_tras_store_id){
                setOritrasId(getData.rel_trans_store_id);
                setFormPurchaseDelivery(formPurchaseDelivery => ({
                      ...formPurchaseDelivery,
                      ori_tras_store_id: getData.rel_trans_store_id,
                      ori_tras_documnettype_id: (getData.rel_trans_documnettype_id===undefined 
                          || getData.rel_trans_documnettype_id===null  
                          || getData.rel_trans_documnettype_id===""
                          || getData.rel_trans_documnettype_id==="0"
                          || getData.rel_trans_documnettype_id===0)?
                          Number(DEFAULTTYPEOFDOCUMENT):getData.rel_trans_documnettype_id,
                      ori_tras_documnettype_name: getData.rel_trans_documnettype_name,
                      ori_tras_documentid: getData.rel_trans_documentid,
                      ori_tras_tradename: getData.rel_trans_tradename,
                      ori_tras_name: getData.rel_trans_name,
                      ori_tras_contacperson: getData.rel_trans_contacperson,
                      ori_tras_nima: getData.ori_tras_nima,
                      ori_tras_pygr: getData.ori_tras_pygr,
                      ori_tras_grnp: getData.ori_tras_grnp, 
                      ori_tras_opt: getData.ori_tras_opt,
                      ori_tras_email: getData.rel_trans_email,
                      ori_tras_street: getData.rel_trans_street,
                      ori_tras_country_id: (getData.rel_trans_country_id===undefined 
                          || getData.rel_trans_country_id===null  
                          || getData.rel_trans_country_id===""
                          || getData.rel_trans_country_id==="0"
                          || getData.rel_trans_country_id===0)?
                          Number(DEFAULTCOUNTRY):getData.rel_trans_country_id,
                      ori_tras_country_name: (getData.rel_trans_country_name===undefined 
                            || getData.rel_trans_country_name===null  
                            || getData.rel_trans_country_name==="" )?
                            DEFAULTCOUNTRY_NAME:getData.rel_trans_country_name,
                      ori_tras_province_id: (getData.rel_trans_province_id===undefined 
                            || getData.rel_trans_province_id===null  
                            || getData.rel_trans_province_id===""
                            || getData.rel_trans_province_id==="0"
                            || getData.rel_trans_province_id===0)?
                            Number(DEFAULTPROVINCE):getData.rel_trans_province_id,
                      ori_tras_province_name: (getData.rel_trans_province_name===undefined 
                            || getData.rel_trans_province_name===null  
                            || getData.rel_trans_province_name==="" )?
                            DEFAULTPROVINCE_NAME:getData.rel_trans_province_name, 
                      ori_tras_postalcode_id: (getData.rel_trans_postalcode_id===undefined 
                            || getData.rel_trans_postalcode_id===null  
                            || getData.rel_trans_postalcode_id===""
                            || getData.rel_trans_postalcode_id==="0"
                            || getData.rel_trans_postalcode_id===0)?
                            Number(DEFAULTPOSTALCODE_ID):getData.rel_trans_postalcode_id,
                      ori_tras_postalcode_code: (getData.rel_trans_postalcode_code===undefined 
                            || getData.rel_trans_postalcode_code===null  
                            || getData.rel_trans_postalcode_code==="" )?
                              DEFAULTPOSTALCODE_CODE:getData.rel_trans_postalcode_code,
                      ori_tras_postalcode_name:   (getData.rel_trans_postalcode_name===undefined 
                            || getData.rel_trans_postalcode_name===null  
                            || getData.rel_trans_postalcode_name==="" )?
                              DEFAULTPOSTALCODE_NAME:getData.rel_trans_postalcode_name  
            }));
          }  
        }         
      } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 
    if (formPurchaseDelivery.ori_tras_documentid && formPurchaseDelivery.ori_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!==""){
      fetchExistNumberDocumentOriTras();
    }  
    return () => { isMounted = false };
  }, [t,token,dispatch,formPurchaseDelivery.ori_tras_documentid,errorsForm,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,setFormPurchaseDelivery,formPurchaseDelivery.ori_tras_store_id,
      DEFAULTPOSTALCODE_NAME,DEFAULTPROVINCE_NAME,DEFAULTTYPEOFDOCUMENT,DEFAULTCOUNTRY,DEFAULTCOUNTRY_NAME,DEFAULTPROVINCE,setOritrasId
  ]);

  useEffect(() => {
      let isMounted = true; 
      const fetchDataVehicles = async () => {
        try {
          const getData = await helpHttp().get8(ENDPOINT,`purchasedelivery/getlistvehiclespurchasedeliveryswithoutfilter`,token,
            (formPurchaseDelivery.vehiclestore_licenseplate!==undefined && formPurchaseDelivery.vehiclestore_licenseplate!==null && formPurchaseDelivery.vehiclestore_licenseplate.replace(/[.\-/\\|]/g, "").trim()!=="")?formPurchaseDelivery.vehiclestore_licenseplate.replace(/[.\-/\\|]/g, "").trim():"-1",
            (formPurchaseDelivery.rel_trans_documentid!==undefined && formPurchaseDelivery.rel_trans_documentid!==null && formPurchaseDelivery.rel_trans_documentid.replace(/[.\-/\\|]/g, "").trim()!=="")?formPurchaseDelivery.rel_trans_documentid.replace(/[.\-/\\|]/g, "").trim():"-1"); 
          if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else if (isMounted) {
            setVehiclesToSelect(getData);
          }
        } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
      };  
      
      if (showModalPurchasesDeliverySettings && ((formPurchaseDelivery.vehiclestore_licenseplate && formPurchaseDelivery.vehiclestore_licenseplate.replace(/[.\-/\\|]/g, "").trim()!=="") || (formPurchaseDelivery.rel_trans_documentid && formPurchaseDelivery.rel_trans_documentid.replace(/[.\-/\\|]/g, "").trim()!==""))) { 
        fetchDataVehicles();
      }else{
        setVehiclesToSelect(initialVehicleToSelect);
    }
      return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formPurchaseDelivery.vehiclestore_licenseplate,showModalPurchasesDeliverySettings,formPurchaseDelivery.rel_trans_documentid]);
    
    useEffect(() => {
      let isMounted = true; 
      const fetchDataDocumentId = async () => {
        try {
          const getData = await helpHttp().get2(ENDPOINT,`purchasedelivery/getlistdocumentidpurchasedeliveryswithoutfilter/`,token,
            (formPurchaseDelivery.rel_trans_documentid!==undefined && formPurchaseDelivery.rel_trans_documentid!==null && formPurchaseDelivery.rel_trans_documentid.replace(/[.\-/\\|]/g, "").trim()!=="")?formPurchaseDelivery.rel_trans_documentid.replace(/[.\-/\\|]/g, "").trim():"-1"); 
          if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else if (isMounted) {
            setDocumentIdToSelect(getData);
          }
        } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
      }; 
      
      if (showModalPurchasesDeliverySettings && formPurchaseDelivery.rel_trans_documentid && formPurchaseDelivery.rel_trans_documentid.replace(/[.\-/\\|]/g, "").trim()!=="") { 
        fetchDataDocumentId();
      }else{
        setDocumentIdToSelect(initialDocumentIdToSelect);
      } 
      return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,showModalPurchasesDeliverySettings,formPurchaseDelivery.rel_trans_documentid]);
  
    useEffect(() => {
      let isMounted = true; 
      const fetchDataDocumentIdOri = async () => {
        try {
          const getData = await helpHttp().get2(ENDPOINT,`purchasedelivery/getlistdocumentidpurchasedeliveryswithoutfilter/`,token,
            (formPurchaseDelivery.ori_tras_documentid!==undefined && formPurchaseDelivery.ori_tras_documentid!==null && formPurchaseDelivery.ori_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="")?formPurchaseDelivery.ori_tras_documentid.replace(/[.\-/\\|]/g, "").trim():"-1"); 
          if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else if (isMounted) {
            setDocumentIdOriToSelect(getData);
          }
        } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
      };  
  
      if (showModalPurchasesDeliverySettings && formPurchaseDelivery.ori_tras_documentid && formPurchaseDelivery.ori_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="") { 
        fetchDataDocumentIdOri();
      }else{
        setDocumentIdOriToSelect(initialDocumentIdToSelect);
      } 
      return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,showModalPurchasesDeliverySettings,formPurchaseDelivery.ori_tras_documentid]);
  
    useEffect(() => {
      let isMounted = true; 
      const fetchDataTradename = async () => {
        try {
          const getData = await helpHttp().get2(ENDPOINT,`purchasedelivery/getlisttradenamepurchasedeliveryswithoutfilter/`,token,
            (formPurchaseDelivery.rel_trans_tradename!==undefined && formPurchaseDelivery.rel_trans_tradename!==null && formPurchaseDelivery.rel_trans_tradename.replace(/[.\-/\\|]/g, "").trim()!=="")?formPurchaseDelivery.rel_trans_tradename.replace(/[.\-/\\|]/g, "").trim():"-1"); 
          if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else if (isMounted) {
            setTradenameToSelect(getData);
          }
        } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
      };  
  
      if (showModalPurchasesDeliverySettings && formPurchaseDelivery.rel_trans_tradename && formPurchaseDelivery.rel_trans_tradename.replace(/[.\-/\\|]/g, "").trim()!=="") { 
        fetchDataTradename();
      }else{
        setTradenameToSelect(initialDocumentIdToSelect);
      } 
      return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,showModalPurchasesDeliverySettings,formPurchaseDelivery.rel_trans_tradename]);
  
    useEffect(() => {
      let isMounted = true; 
      const fetchDataTradenameOri = async () => {
        try {
          const getData = await helpHttp().get2(ENDPOINT,`purchasedelivery/getlisttradenamepurchasedeliveryswithoutfilter/`,token,
            (formPurchaseDelivery.ori_tras_tradename!==undefined && formPurchaseDelivery.ori_tras_tradename!==null && formPurchaseDelivery.ori_tras_tradename.replace(/[.\-/\\|]/g, "").trim()!=="")?formPurchaseDelivery.ori_tras_tradename.replace(/[.\-/\\|]/g, "").trim():"-1"); 
          if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else if (isMounted) {
            setTradenameOriToSelect(getData);
          }
        } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
      };  
      
      if (showModalPurchasesDeliverySettings && formPurchaseDelivery.ori_tras_tradename && formPurchaseDelivery.ori_tras_tradename.replace(/[.\-/\\|]/g, "").trim()!=="") { 
        fetchDataTradenameOri();
      }else{
        setTradenameOriToSelect(initialWorkPlaceToSelect);
      } 
      return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,showModalPurchasesDeliverySettings,formPurchaseDelivery.ori_tras_tradename]);
  
    useEffect(() => {
      let isMounted = true; 
      const fetchDataWorkPlace = async () => {
        try {
          const getData = await helpHttp().get2(ENDPOINT,`purchasedelivery/getlistworplacepurchasedelivery/`,token,
            (formPurchaseDelivery.ori_tras_documentid!==undefined && formPurchaseDelivery.ori_tras_documentid!==null && formPurchaseDelivery.ori_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="")?formPurchaseDelivery.ori_tras_documentid.replace(/[.\-/\\|]/g, "").trim():"-1"); 
          if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else if (isMounted) {
            setWorkPlaceToSelect(getData);
          }
        } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
      };  
      
      if (showModalPurchasesDeliverySettings && formPurchaseDelivery.ori_tras_documentid && formPurchaseDelivery.ori_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="") { 
        fetchDataWorkPlace();
      }else{
        setWorkPlaceToSelect(initialWorkPlaceToSelect);
      }
      return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,showModalPurchasesDeliverySettings,formPurchaseDelivery.ori_tras_street,formPurchaseDelivery.ori_tras_documentid]);
  
 
  useEffect(() => {
    let isMounted = true;
  
    const fetchDataPayment = async () => {
      try {
        const getData = i18n.language === "es"
        ? await helpHttp().get(ENDPOINT, `paymenttype/paymenttypesorderbynamees`, token)
        : await helpHttp().get(ENDPOINT, `paymenttype/paymenttypesorderbynameen`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setPaymenetTypeSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 
 
    if (showModalPurchasesDeliverySettings ) {  
      fetchDataPayment(); 
    }
    return () => { isMounted = false };

  }, [t,token,dispatch,i18n,roles,showModalPurchasesDeliverySettings]);

   useEffect(() => {
      let isMounted = true; 
      const fetchDataPostalCodeOri = async () => {
          try {
              const getData = await helpHttp().get2(ENDPOINT,`purchasedelivery/getlistpostalcode/`,token,
                  (formPurchaseDelivery.ori_tras_postalcode_code!==undefined && formPurchaseDelivery.ori_tras_postalcode_code!==null && formPurchaseDelivery.ori_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim()!=="")?formPurchaseDelivery.ori_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim():"-1"); 
              if (getData.err) {
                  dispatch(warningErrorAction(t('Text_InvalidCredentials')));
              } else if (isMounted) {
                  setPostalCodeOriToSelect(getData);
              }
          } catch (error) {
              dispatch(warningErrorAction(t('Text_IncorrectData'))); 
          }
      };  
      if (formPurchaseDelivery.ori_tras_postalcode_code && formPurchaseDelivery.ori_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim()!=="") { 
        fetchDataPostalCodeOri();
      }
      return () => { isMounted = false };
  }, [t,token,dispatch,i18n,roles,formPurchaseDelivery.ori_tras_postalcode_code,DEFAULTPROVINCE,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPROVINCE_NAME]);
  
   
  const isValidPngDataURL = (value) => {
    if (typeof value !== "string") return false;
    const trimmed = value.trim();
    if (trimmed==="") return false;
    if (trimmed.includes("static/media")) return true; 
    if (!trimmed.startsWith("data:image/png;base64,")) return false;
    // longitud mínima razonable para un PNG (ajusta si quieres)
    return trimmed.length > 200; 
  };
   
  useEffect(() => {
    let isMounted = true;
    const fetchDataPurchaseDelivery = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await  helpHttp().get2(ENDPOINT,`purchasedelivery/getpurchasedeliverybyid/`,token,id);
        if (getData.err) {
          setFormPurchaseDelivery(initialStatePurchaseDelivery);
          setIsLoadingErrorData(true);
           dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setTrasporterId(getData.rel_trans_store_id);
          setOritrasId(getData.ori_tras_store_id);
          setFormPurchaseDelivery(getData);
          dispatch(setLoading(false));
          if (getData.signature_dispatched_by && isValidPngDataURL(getData.signature_dispatched_by)) {
            setTimeout(() => {
              if (signDispatchedOptTrasCanvas.current) {
                drawSignatureCentered(signDispatchedOptTrasCanvas, getData.signature_dispatched_by);
              }
            }, 0);
          } 
            if (getData.signature_client && isValidPngDataURL(getData.signature_client)) {
            setTimeout(() => {
              if (signDispatchedDestTrasCanvas.current) {
                drawSignatureCenteredClient(signDispatchedDestTrasCanvas, getData.signature_client);
              }
            }, 0);
          }  
        }  
      } catch (error) {
         dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };

    if (id!=="0"){
      if (formPurchaseDelivery.id===""){
        fetchDataPurchaseDelivery();  
      }
    }else{
      setFormPurchaseDelivery(initialStatePurchaseDelivery);
      setTrasporterId(0);
      setOritrasId(0);
      setFormPurchaseDelivery(formPurchaseDelivery => ({
        ...formPurchaseDelivery,
        defaultStore_id:defaultStore.id,
        useraccount_id:useraccount_id,
        defaultformatnumber:defaulttypesdi,
        isfinished:false,
        purchasenote:0,
        numberticket:"",
        ownnumberpurchase:"",
        datepurchase:null,
        vehiclestore_id: 0,
        vehiclestore_licenseplate: "",
        vehiclestore_defaultdriver: "",
        vehiclestore_store_id: 0,

        rel_trans_store_id:0,
        rel_trans_documnettype_id:0,
        rel_trans_documentid:"",
        rel_trans_documnettype_name:"",
        rel_trans_tradename:"",
        rel_trans_name:"",
        rel_trans_contacperson:"",
        rel_trans_nima: "",
        rel_trans_pygr: "",
        rel_trans_grnp:"",
        rel_trans_opt: 0,
        rel_trans_roadtype_id: Number(DEFAULTROADTYE),
        rel_trans_street: "",
        rel_trans_country_id: Number(DEFAULTCOUNTRY),
        rel_trans_country_name:DEFAULTCOUNTRY_NAME,
        rel_trans_province_id: Number(DEFAULTPROVINCE),
        rel_trans_province_name:DEFAULTPROVINCE_NAME,
        rel_trans_postalcode_id: Number(DEFAULTPOSTALCODE_ID),
        rel_trans_postalcode_code:  DEFAULTPOSTALCODE_CODE,
        rel_trans_postalcode_name: DEFAULTPOSTALCODE_NAME,

        ori_tras_store_id: 0,
        ori_tras_documnettype_id: 0,
        ori_tras_documnettype_name:"",
        ori_tras_documentid:"",
        ori_tras_tradename:"",
        ori_tras_name:"",
        ori_tras_contacperson:"",
        ori_tras_nima: "",
        ori_tras_pygr: "",
        ori_tras_grnp:"",
        ori_tras_opt: 0,
        ori_tras_workplace: "",
        ori_tras_roadtype_id: Number(DEFAULTROADTYE),
        ori_tras_street: "",
        ori_tras_country_id: Number(DEFAULTCOUNTRY),
        ori_tras_country_name:DEFAULTCOUNTRY_NAME,
        ori_tras_province_id: Number(DEFAULTPROVINCE),
        ori_tras_province_name:DEFAULTPROVINCE_NAME,
        ori_tras_postalcode_id: Number(DEFAULTPOSTALCODE_ID),
        ori_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
        ori_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
        ori_tras_email:"",

        observations:"", 
        totalpurchasedelivery: 0,
        totaldiscountpurchasedelivery: 0,
        totaltaxespurchasedelivery: 0,
        totalNetoPurchasedelivery:0,
        enabled:true,
        subownnumberpurchase:0,
        payment_id:2, 
        payment_code: "",
        payment_namees: "",
        payment_nameen: "", 
        totalWeigthNeto:0,
        signature_dispatched_by:"",
        signature_client:"",
        linespurchasedelivery: [] 

      }));
      setFormPurchaseDelivery(formPurchaseDelivery => ({
        ...formPurchaseDelivery,
        linespurchasedelivery:[]
      })); 
      signDispatchedOptTrasCanvas.current.clear();
      signDispatchedDestTrasCanvas.current.clear();
    }
    return () => { isMounted = false };
  }, [dispatch,id,t,token,formPurchaseDelivery.id,DEFAULTCOUNTRY_NAME,DEFAULTPOSTALCODE_CODE,defaultStore.id,defaulttypesdi,useraccount_id,setOritrasId,setTrasporterId,
    DEFAULTPOSTALCODE_ID,DEFAULTPOSTALCODE_NAME,DEFAULTPROVINCE_NAME,DEFAULTROADTYE,DEFAULTCOUNTRY,DEFAULTPROVINCE
  ]);   
  
 return (
      <>
        {showModalPurchasesDeliverySettings ? ( 
          <div className="container-fluid formgeneral-send-wrapper">
            <Box sx={{ bgcolor: '#ffffff', width: '1540px'}}>
              <form onSubmit={handleCloseDataEditPurchaseDelivery}>
                {/* HEADER */}
                <div className="formgeneral-card-header">
                  <div className="formgeneral-header-content">
                    <div className="formgeneral-header-title2">
                      {isLoadingErrorData?
                        <i className="fas fa-solid fa-exclamation fa-2x text-danger"/>:
                        (isLoadingData?
                        <CircularProgress sx={{ color : "#f6c23e"}}/>:
                        <i className="fas fa-regular fa-clipboard text-warning"></i>)} 
                        &nbsp;&nbsp;{id==="0"?t('TextPurchaseDeliver_New')+': '+formPurchaseDelivery.purchasenote:t('Text_PurchaseDeliver_Edit')+': '+formPurchaseDelivery.purchasenote}
                    </div>
                    <div className="email-card-actions">
                      {!isLoadingData && (
                        <>
                          <button type="button" className="formgeneral-send-btn" onClick={handleSubmitDataEditPurchaseEdit} >
                            {id==="0"?t('Button_Create'):t('Button_Update')}
                          </button>
                          <button type="button" className="formgeneral-cancel-btn" onClick={handleCloseDataEditPurchaseDelivery} >
                            {t('Button_Cancel')}
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <br/>  
                {!isLoadingData ?
                  <>
                    <div className="formgeneral-card-form">
                      <div className="row p-2"> 
                        <div className="form-group">   
                          <label className="text-danger" style={{ fontSize: 18 }}>{t('Text_PURCHASEDELIVERY_REF_UPPER').toUpperCase()} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <TextField
                            id="ownnumberpurchase" 
                            name="ownnumberpurchase"
                            value={formPurchaseDelivery.ownnumberpurchase}
                            format={i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy"} 
                            inputProps={{ style: {width: i18n.language==='es'?309:271,  fontSize: '18px', }, maxLength: 20 }}
                            style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            label={errorsForm.ownnumberpurchase!=null?t(errorsForm.ownnumberpurchase):t('Text_PURCHASEDELIVERY_REF_UPPER')}
                            placeholder={t('Text_PURCHASEDELIVERY_REF_UPPER')}
                            variant="standard"
                            onBlur={handleBlurDataEditPurchaseDelivery}
                            onChange={handleChangeDataEditPurchaseDelivery}
                          />
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PURCHASEDELIVERY_DATEPURCHAE').toUpperCase()} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <DesktopDatePicker
                              id="datepurchase" 
                              name="datepurchase"
                              value={ formPurchaseDelivery.datepurchase!== null ? new Date(formPurchaseDelivery.datepurchase):null}
                              format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                              inputProps={{ style: { width: 220 }, maxLength: 200 }}
                              label={errorsForm.datepurchase!=null?t(errorsForm.datepurchase):t('Text_PurchaseDeliver_Date')}
                              onBlur={handleBlurSelectDate}
                              onChange={handleChangeSelectDate}
                              slotProps={{
                                textField: {
                                  placeholder: i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy",
                                  sx: {
                                    maxLength: 220,
                                    width: 220,
                                    fontSize: '18px',  
                                  },
                                  InputProps: {
                                    style: {
                                      fontSize: '18px',
                                    }
                                  },
                                  InputLabelProps:{ 
                                    style: {
                                      fontSize: '18px', 
                                      background: '#FFFFFF'
                                    }
                                  },
                                },
                              }}
                            />
                          </LocalizationProvider>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <label className="text-primary">{t('Text_PurchaseDeliver_TOTAL')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <NumericFormat 
                            thousandSeparator=","
                            decimalSeparator="."
                            decimalScale={2}
                            fixedDecimalScale
                            allowNegative
                            isAllowed={withValueCap3}
                            id="total"
                            name="total"
                            suffix=" €"
                            value={formPurchaseDelivery.totalNetoPurchasedelivery}
                            className="total-field-blue"
                            disabled
                          /> 
                          <hr className="sidebar-divider d-none d-md-block"/>
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PURCHASEDELIVERY_CIF_TRANS').toUpperCase()} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <span style={{ position: "relative" }}>
                            <TextField
                              id="rel_trans_documentid"
                              name="rel_trans_documentid"
                              value={formPurchaseDelivery.rel_trans_documentid}
                              onChange={(e) => {
                                setFormPurchaseDelivery(prev => ({
                                  ...prev,
                                  rel_trans_documentid: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchDocumentId(e.target.value);
                              }}
                              onKeyDown={handleKeyDownDocumentId}
                              onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                  handleBlur();
                                }
                              }}
                              label={errorsForm.rel_trans_documentid!=null?t(errorsForm.rel_trans_documentid):t('Text_PURCHASEDELIVERY_CIF_TRANS')}
                              placeholder={t('Text_PURCHASEDELIVERY_CIF_TRANS')}
                              variant="standard"
                              inputProps={{ style: {width: i18n.language==='es'?161:161,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            />  
                            {/* Desplegable dinámico */}
                            {filteredDocumentId.length > 0 && (
                              <div
                                className="dropdown-class"
                                style={{
                                  position: "absolute",
                                  left:'0px',
                                  border: "2px solid #4e73df", // Borde azul (#4e73df)
                                  borderRadius: "4px",
                                  marginTop: "4px",
                                  maxHeight: "200px",
                                  overflowY: "auto",
                                  width: "350%",
                                  fontSize: '18px',
                                  backgroundColor: "#f8f9fa", // Fondo gris claro
                                  zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                              >
                                {filteredDocumentId.map((store, index) => (
                                  <MenuItem
                                      key={store.id}
                                      onClick={() => handleSelectDocumentId(store)}
                                      style={{
                                          cursor: "pointer",
                                          padding: "8px",
                                          borderBottom: "1px solid #eee",
                                          fontSize: '18px',
                                          backgroundColor:
                                          index === highlightedIndexDocumentId ? "#4e73df" : "transparent",
                                          color: index === highlightedIndexDocumentId ? "white" : "black",
                                      }}
                                  >
                                    {store.documentid} - {store.tradename}
                                  </MenuItem>
                                ))}
                              </div>
                            )}
                          </span> 
                          &nbsp;&nbsp;
                          <IconButton  size="small"  className="deletesmall-select-button" onClick={deleteDataStoreRelTrans}>
                            <DeleteIcon style={{fontSize: 24}}/>
                          </IconButton> 
                          &nbsp;&nbsp;
                          {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Purchases_Store_Master'))&&
                            <IconButton  size="small"  className="edit-select-button" onClick={searchStoreRelTrans}>
                              <SearchIcon style={{fontSize: 24}}/>
                            </IconButton> 
                          }
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PURCHASEDELIVERY_LICENSEPLATE').toUpperCase()} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <span style={{ position: "relative" }} >
                            <TextField
                              id="vehiclestore_licenseplate"
                              name="vehiclestore_licenseplate"
                              value={formPurchaseDelivery.vehiclestore_licenseplate}
                              onChange={(e) => {
                                setFormPurchaseDelivery(prev => ({
                                  ...prev,
                                  vehiclestore_licenseplate: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchVehicle(e.target.value);
                              }}
                              onKeyDown={handleKeyDownVehicleFrom}
                              onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                  handleBlur();
                                }
                              }}
                              label={errorsForm.vehiclestore_licenseplate != null
                                ? t(errorsForm.vehiclestore_licenseplate)
                                : t('Placeholder_PURCHASEDELIVERY_LICENSEPLATE')}
                              placeholder={t('Placeholder_PURCHASEDELIVERY_LICENSEPLATE')}
                              inputProps={{ style: {width: i18n.language==='es'?210:210,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              variant="standard"
                            />  
                            {/* Desplegable dinámico */}
                            {filteredVehicle.length > 0 && (
                              <div
                                className="dropdown-class"
                                style={{
                                  position: "absolute",
                                  left:'0px',
                                  border: "2px solid #4e73df", // Borde azul (#4e73df)
                                  borderRadius: "4px",
                                  marginTop: "4px",
                                  maxHeight: "200px",
                                  overflowY: "auto",
                                  width: "100%",
                                  fontSize: '18px',
                                  backgroundColor: "#f8f9fa", // Fondo gris claro
                                  zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                              >
                                {filteredVehicle.map((vehicle, index) => (
                                  <MenuItem
                                      key={vehicle.id}
                                      onClick={() => handleSelectVehicleFrom(vehicle)}
                                      style={{
                                          cursor: "pointer",
                                          padding: "8px",
                                          borderBottom: "1px solid #eee",
                                          fontSize: '18px',
                                          backgroundColor:
                                          index === highlightedIndexVehicle ? "#4e73df" : "transparent",
                                          color: index === highlightedIndexVehicle ? "white" : "black",
                                      }}
                                  >
                                    {vehicle.licenseplate}
                                  </MenuItem>
                                ))}
                              </div>
                            )}
                          </span> 
                          &nbsp;&nbsp;
                           <IconButton  size="small"  className="deletesmall-select-button" onClick={deleteDataVehicles}>
                            <DeleteIcon style={{fontSize: 24}}/>
                          </IconButton>  
                          &nbsp;&nbsp;
                          {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Purchases_Store_Master'))&&
                            <IconButton  size="small"  className="edit-select-button" onClick={searchVehicles}>
                              <SearchIcon style={{fontSize: 24}}/>
                            </IconButton>  
                          } 
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PURCHASEDELIVERY_TRADENAME_TRANS').toUpperCase()} :</label> 
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <span style={{ position: "relative" }} >
                            <TextField
                              id="rel_trans_tradename"
                              name="rel_trans_tradename"
                              value={formPurchaseDelivery.rel_trans_tradename}
                              onChange={(e) => {
                                setFormPurchaseDelivery(prev => ({
                                  ...prev,
                                  rel_trans_tradename: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchTradename(e.target.value);
                              }}
                              onKeyDown={handleKeyDownTradename}
                              onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                  handleBlur();
                                }
                              }}
                              label={errorsForm.rel_trans_tradename!=null?t(errorsForm.rel_trans_tradename):t('Placeholder_PURCHASEDELIVERY_NAME_TRANS')}
                              placeholder={t('Placeholder_PURCHASEDELIVERY_NAME_TRANS')}
                              variant="standard"
                              inputProps={{ style: {width: i18n.language==='es'?394:363,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            />
                            {/* Desplegable dinámico */}
                            {filteredTradename.length > 0 && (
                              <div
                                className="dropdown-class"
                                style={{
                                  position: "absolute",
                                  left:'0px',
                                  border: "2px solid #4e73df", // Borde azul (#4e73df)
                                  borderRadius: "4px",
                                  marginTop: "4px",
                                  maxHeight: "200px",
                                  overflowY: "auto",
                                  width: "150%",
                                  fontSize: '18px',
                                  backgroundColor: "#f8f9fa", // Fondo gris claro
                                  zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                              >
                                {filteredTradename.map((store, index) => (
                                  <MenuItem
                                      key={store.id}
                                      onClick={() => handleSelectTradeName(store)}
                                      style={{
                                          cursor: "pointer",
                                          padding: "8px",
                                          borderBottom: "1px solid #eee",
                                          fontSize: '18px',
                                          backgroundColor:
                                          index === highlightedIndexTradename ? "#4e73df" : "transparent",
                                          color: index === highlightedIndexTradename ? "white" : "black",
                                      }}
                                  >
                                    {store.tradename} - {store.documentid}
                                  </MenuItem>
                                ))}
                              </div>
                            )}
                          </span>
                        </div>
                      </div>

                      <div className="row p-2"> 
                        <div className="form-group">   
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PURCHASEDELIVERY_TRADENAME_NIMA').toUpperCase()} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <TextField
                            id="rel_trans_nima" 
                            name="rel_trans_nima"
                            value={formPurchaseDelivery.rel_trans_nima}
                            inputProps={{ style: {width: i18n.language==='es'?200:200,  fontSize: '18px', }, maxLength: 100 }}
                            style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            label={errorsForm.rel_trans_nima!=null?t(errorsForm.rel_trans_nima):t('Placeholder_PURCHASEDELIVERY_TRADENAME_NIMA')}
                            placeholder={t('Placeholder_PURCHASEDELIVERY_TRADENAME_NIMA')}
                            variant="standard"
                            onBlur={handleBlurDataEditPurchaseDelivery}
                            onChange={handleChangeDataEditPurchaseDelivery}
                          />
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <label className="text-primary">{t('Text_PURCHASEDELIVERY_TRADENAME_PYGR')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <TextField
                            id="rel_trans_grnp" 
                            name="rel_trans_grnp"
                            value={formPurchaseDelivery.rel_trans_grnp}
                            inputProps={{ style: {width: i18n.language==='es'?200:200,  fontSize: '18px', }, maxLength: 100 }}
                            style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            label={errorsForm.rel_trans_grnp!=null?t(errorsForm.rel_trans_grnp):t('Placeholder_PURCHASEDELIVERY_TRADENAME_PYGR')}
                            placeholder={t('Placeholder_PURCHASEDELIVERY_TRADENAME_PYGR')}
                            variant="standard"
                            onBlur={handleBlurDataEditPurchaseDelivery}
                            onChange={handleChangeDataEditPurchaseDelivery}
                          />
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <label className="text-primary">{t('Text_PURCHASEDELIVERY_TRADENAME_DRIVER')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <TextField
                            id="vehiclestore_defaultdriver" 
                            name="vehiclestore_defaultdriver"
                            value={formPurchaseDelivery.vehiclestore_defaultdriver}
                            inputProps={{ style: {width: i18n.language==='es'?762:806,  fontSize: '18px', }, maxLength: 100 }}
                            style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            label={errorsForm.vehiclestore_defaultdriver!=null?t(errorsForm.vehiclestore_defaultdriver):t('Placeholder_PURCHASEDELIVERY_TRADENAME_DRIVER')}
                            placeholder={t('Placeholder_PURCHASEDELIVERY_TRADENAME_DRIVER')}
                            variant="standard"
                            onBlur={handleBlurDataEditPurchaseDelivery}
                            onChange={handleChangeDataEditPurchaseDelivery}
                          />
                          <hr className="sidebar-divider d-none d-md-block"/>
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PURCHASEDELIVERY_CIF_STORE').toUpperCase()} :</label>  
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <span style={{ position: "relative" }}>
                            <TextField
                              id="ori_tras_documentid"
                              name="ori_tras_documentid"
                              value={formPurchaseDelivery.ori_tras_documentid}
                              onChange={(e) => {
                                setFormPurchaseDelivery(prev => ({
                                  ...prev,
                                  ori_tras_documentid: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchDocumentIdOri(e.target.value);
                              }}
                              onKeyDown={handleKeyDownDocumentIdOri}
                              onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                  handleBlur();
                                }
                              }}
                              label={errorsForm.ori_tras_documentid!=null?t(errorsForm.ori_tras_documentid):t('Text_PURCHASEDELIVERY_CIF_STORE')}
                              placeholder={t('Text_PURCHASEDELIVERY_CIF_STORE')}
                              variant="standard"
                              inputProps={{ style: {width: i18n.language==='es'?161:161,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            />  
                            {/* Desplegable dinámico */}
                            {filteredDocumentIdOri.length > 0 && (
                              <div
                                className="dropdown-class"
                                style={{
                                  position: "absolute",
                                  left:'0px',
                                  border: "2px solid #4e73df", // Borde azul (#4e73df)
                                  borderRadius: "4px",
                                  marginTop: "4px",
                                  maxHeight: "200px",
                                  overflowY: "auto",
                                  width: "350%",
                                  fontSize: '18px',
                                  backgroundColor: "#f8f9fa", // Fondo gris claro
                                  zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                              >
                                {filteredDocumentIdOri.map((store, index) => (
                                  <MenuItem
                                      key={store.id}
                                      onClick={() => handleSelectDocumentIdOri(store)}
                                      style={{
                                          cursor: "pointer",
                                          padding: "8px",
                                          borderBottom: "1px solid #eee",
                                          fontSize: '18px',
                                          backgroundColor:
                                          index === highlightedIndexDocumentIdOri ? "#4e73df" : "transparent",
                                          color: index === highlightedIndexDocumentIdOri ? "white" : "black",
                                      }}
                                  >
                                    {store.documentid} - {store.tradename}
                                  </MenuItem>
                                ))}
                              </div>
                            )}
                          </span>    
                          &nbsp;&nbsp;
                          <IconButton  size="small"  className="deletesmall-select-button" onClick={deleteDataStoreOriTras}>
                            <DeleteIcon style={{fontSize: 24}}/>
                          </IconButton> 
                          &nbsp;&nbsp;
                          {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Tickets_Store_Master'))&&
                            <IconButton  size="small"  className="edit-select-button" onClick={searchStoreOriTras}>
                              <SearchIcon style={{fontSize: 24}}/>
                            </IconButton>  
                          } 
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PURCHASEDELIVERY_TRADENAME_STORE').toUpperCase()} :</label>   
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <span style={{ position: "relative" }} >
                            <TextField
                              id="ori_tras_tradename"
                              name="ori_tras_tradename"
                              value={formPurchaseDelivery.ori_tras_tradename}
                              onChange={(e) => {
                                setFormPurchaseDelivery(prev => ({
                                  ...prev,
                                  ori_tras_tradename: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchTradenameOri(e.target.value);
                              }}
                              onKeyDown={handleKeyDownTradenameOri}
                              onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                  handleBlur();
                                }
                              }}
                              label={errorsForm.ori_tras_tradename!=null?t(errorsForm.ori_tras_tradename):t('Placeholder_PURCHASEDELIVERY_TRADENAME_STORE')}
                              placeholder={t('Placeholder_PURCHASEDELIVERY_TRADENAME_STORE')}
                              variant="standard"
                              inputProps={{ style: {width: i18n.language==='es'?542:524,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            /> 
                            {/* Desplegable dinámico */}
                            {filteredTradenamedOri.length > 0 && (
                              <div
                                className="dropdown-class"
                                style={{
                                  position: "absolute",
                                  left:'0px',
                                  border: "2px solid #4e73df", // Borde azul (#4e73df)
                                  borderRadius: "4px",
                                  marginTop: "4px",
                                  maxHeight: "200px",
                                  overflowY: "auto",
                                  width: "100%",
                                  fontSize: '18px',
                                  backgroundColor: "#f8f9fa", // Fondo gris claro
                                  zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                              >
                                {filteredTradenamedOri.map((store, index) => (
                                  <MenuItem
                                      key={store.id}
                                      onClick={() => handleSelectTradeNameOri(store)}
                                      style={{
                                          cursor: "pointer",
                                          padding: "8px",
                                          borderBottom: "1px solid #eee",
                                          fontSize: '18px',
                                          backgroundColor:
                                          index === highlightedIndexTradenamedOri ? "#4e73df" : "transparent",
                                          color: index === highlightedIndexTradenamedOri ? "white" : "black",
                                      }}
                                  >
                                    {store.tradename} - {store.documentid}
                                  </MenuItem>
                                ))}
                              </div>
                            )}
                          </span>  
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PURCHASEDELIVERY_EMAIL_STORE').toUpperCase()} :</label>    
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <TextField
                            id="ori_tras_email" 
                            name="ori_tras_email"
                            value={formPurchaseDelivery.ori_tras_email}
                            inputProps={{ style: {width: i18n.language==='es'?270:270,  fontSize: '18px', }, maxLength: 100 }}
                            style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}   
                            label={errorsForm.ori_tras_email!=null?t(errorsForm.ori_tras_email):t('Placeholder_PURCHASEDELIVERY_EMAIL_STORE')}
                            placeholder={t('Placeholder_PURCHASEDELIVERY_EMAIL_STORE')}
                            variant="standard"
                            onBlur={handleBlurDataEditPurchaseDelivery}
                            onChange={handleChangeDataEditPurchaseDelivery} 
                          />  
                        </div>
                      </div>

                      <div className="row p-2"> 
                        <div className="form-group"> 
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PURCHASEDELIVERY_TRADENAME_WORKPLACE').toUpperCase()} :</label>    
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <span style={{ position: "relative" }} >
                            <TextField
                              id="ori_tras_workplace"
                              name="ori_tras_workplace"
                              value={formPurchaseDelivery.ori_tras_workplace}
                              onChange={(e) => {
                                setFormPurchaseDelivery(prev => ({
                                  ...prev,
                                  ori_tras_workplace: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchWorkPlace(e.target.value);
                              }}
                              onKeyDown={handleKeyDownWorkPlace}
                              onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                  handleBlur();
                                }
                              }}
                              label={errorsForm.ori_tras_workplace!=null?t(errorsForm.ori_tras_workplace):t('Placeholder_PURCHASEDELIVERY_TRADENAME_WORKPLACE')}
                              placeholder={t('Placeholder_PURCHASEDELIVERY_TRADENAME_WORKPLACE')}
                              variant="standard"
                              inputProps={{ style: {width: i18n.language==='es'?1431:1367,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            /> 
                            {/* Desplegable dinámico */}
                            {filteredWorkPlace.length > 0 && (
                              <div
                                className="dropdown-class"
                                style={{
                                  position: "absolute",
                                  left:'0px',
                                  border: "2px solid #4e73df", // Borde azul (#4e73df)
                                  borderRadius: "4px",
                                  marginTop: "4px",
                                  maxHeight: "200px",
                                  overflowY: "auto",
                                  width: "100%",
                                  fontSize: '18px',
                                  backgroundColor: "#f8f9fa", // Fondo gris claro
                                  zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                              >
                                {filteredWorkPlace.map((store, index) => (
                                  <MenuItem
                                      key={store.id}
                                      onClick={() => handleSelectWorkPlace(store)}
                                      style={{
                                          cursor: "pointer",
                                          padding: "8px",
                                          borderBottom: "1px solid #eee",
                                          fontSize: '18px',
                                          backgroundColor:
                                          index === highlightedIndexWorkPlace ? "#4e73df" : "transparent",
                                          color: index === highlightedIndexWorkPlace ? "white" : "black",
                                      }}
                                      onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                  >
                                    {store.workplace}
                                  </MenuItem>
                                ))}
                              </div>
                            )}
                          </span> 
                        </div>
                      </div>

                      <div className="row p-2"> 
                        <div className="form-group"> 
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PURCHASEDELIVERY_TRADENAME_STORE_ADDRESS').toUpperCase()} :</label>    
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <TextField
                            id="ori_tras_street" 
                            name="ori_tras_street"
                            value={formPurchaseDelivery.ori_tras_street}
                            inputProps={{ style: {width: i18n.language==='es'?517:562,  fontSize: '18px', }, maxLength: 255 }}
                            style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            label={errorsForm.ori_tras_street!=null?t(errorsForm.ori_tras_street):t('Placeholder_PURCHASEDELIVERY_TRADENAME_STORE_ADDRESS')}
                            placeholder={t('Placeholder_PURCHASEDELIVERY_TRADENAME_STORE_ADDRESS')}
                            variant="standard"
                            onBlur={handleBlurDataEditPurchaseDelivery}
                            onChange={handleChangeDataEditPurchaseDelivery} 
                          />  
                          &nbsp;&nbsp;
                          <IconButton  size="small"  className="deletesmall-select-button" onClick={deleteDataStoreAddressOriTras}>
                            <DeleteIcon style={{fontSize: 24}}/>
                          </IconButton>  
                          &nbsp;&nbsp;
                          {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Settings_Tickets_Store_Master'))&&
                            <IconButton  size="small"  className="edit-select-button" 
                                disabled={formPurchaseDelivery.ori_tras_store_id===undefined
                                        || formPurchaseDelivery.ori_tras_store_id===""
                                        || formPurchaseDelivery.ori_tras_store_id==="0"
                                        || formPurchaseDelivery.ori_tras_store_id===0 }
                                         onClick={searchStoreAddress}>
                                <SearchIcon style={{fontSize: 24}}/>
                              </IconButton> 
                          } 
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PURCHASEDELIVERY_TRADENAME_STORE_POSTALCODE')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <span style={{ position: "relative" }}>
                              <TextField
                                  id="ori_tras_postalcode_code"
                                  name="ori_tras_postalcode_code"
                                  value={formPurchaseDelivery.ori_tras_postalcode_code}
                                  onChange={(e) => {
                                        setFormPurchaseDelivery(prev => ({
                                          ...prev,
                                          ori_tras_postalcode_code: e.target.value.toUpperCase()
                                      }));
                                      debouncedHandleSearchPostalCode(e.target.value);
                                  }}
                                  onKeyDown={handleKeyDownDPostalCodeOri}
                                  onBlur={(event) => {
                                      if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                          const inputPostalCode = formPurchaseDelivery.ori_tras_postalcode_code.trim().toUpperCase();
                                          const matchedPostal = postalCodeOriToSelect.find((postal) => {
                                          const normalizedPostal = postal.postalcode?.toUpperCase() || "";
                                          return normalizedPostal === inputPostalCode;
                                          });

                                          if (matchedPostal) {
                                              setFormPurchaseDelivery((prev) => ({
                                                  ...prev,
                                                  ori_tras_postalcode_id: matchedPostal.id || Number(DEFAULTPOSTALCODE_ID),
                                                  ori_tras_postalcode_code: matchedPostal.postalcode || DEFAULTPOSTALCODE_CODE,
                                                  ori_tras_postalcode_name: matchedPostal.name || DEFAULTPOSTALCODE_NAME,
                                                  ori_tras_province_id: matchedPostal.province_id || Number(DEFAULTPROVINCE), 
                                                  ori_tras_province_name: matchedPostal.province_name || DEFAULTPROVINCE_NAME
                                              }));
                                          } else {
                                              setFormPurchaseDelivery((prev) => ({
                                                  ...prev,
                                                  ori_tras_postalcode_id: Number(DEFAULTPOSTALCODE_ID),
                                                  ori_tras_postalcode_code: DEFAULTPOSTALCODE_CODE,
                                                  ori_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
                                                  ori_tras_province_id: Number(DEFAULTPROVINCE),
                                                  ori_tras_province_name: DEFAULTPROVINCE_NAME
                                              }));
                                          }
                                          setFilteredpostalCodeOri([]);
                                          setHighlightedIndexPostalCodeOri(-1);
                                      }
                                  }}
                                  label={errorsForm.ori_tras_postalcode_code!=null && errorsForm.ori_tras_postalcode_code!==""?t(errorsForm.ori_tras_postalcode_code):t('Text_PURCHASEDELIVERY_TRADENAME_STORE_POSTALCODE')}
                                  placeholder={t('Text_PURCHASEDELIVERY_TRADENAME_STORE_POSTALCODE')}
                                  variant="standard"
                                  inputProps={{ style: {width: i18n.language==='es'?100:100,  fontSize: '18px', }, maxLength: 100 }}
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              />  
                              {/* Desplegable dinámico */}
                              {filteredpostalCodeOri.length > 0 && (
                                  <div
                                      className="dropdown-class"
                                      style={{
                                          position: "absolute",
                                          left:'0px',
                                          border: "2px solid #4e73df", // Borde azul (#4e73df)
                                          borderRadius: "4px",
                                          marginTop: "4px",
                                          maxHeight: "200px",
                                          overflowY: "auto",
                                          width: "700%", 
                                          fontSize: '18px',
                                          backgroundColor: "#f8f9fa", // Fondo gris claro
                                          zIndex: 1000,
                                      }}
                                      onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                  >
                                      {filteredpostalCodeOri.map((postal, index) => (
                                      <MenuItem
                                          key={postal.id}
                                          onClick={() => handleSelectPostalCodeOri(postal)}
                                          style={{
                                              cursor: "pointer",
                                              padding: "8px",
                                              borderBottom: "1px solid #eee",
                                              fontSize: '18px',
                                              backgroundColor:
                                              index === highlightedIndexPostalCodeOri ? "#4e73df" : "transparent",
                                              color: index === highlightedIndexPostalCodeOri ? "white" : "black",
                                          }}
                                      >
                                          {postal.postalcode} - {postal.name} - {postal.province_name}
                                      </MenuItem>
                                      ))}
                                  </div>
                              )}
                          </span>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PURCHASEDELIVERY_TRADENAME_STORE_LOCALITY')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <TextField
                              id="ori_tras_postalcode_name" 
                              name="ori_tras_postalcode_name"
                              value={formPurchaseDelivery.ori_tras_postalcode_name}
                              inputProps={{ style: {width: i18n.language==='es'?350:350,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={errorsForm.ori_tras_postalcode_name!=null && errorsForm.ori_tras_postalcode_name!==""?t(errorsForm.ori_tras_contactname):t('Text_PURCHASEDELIVERY_TRADENAME_STORE_LOCALITY')}
                              placeholder={t('Text_PURCHASEDELIVERY_TRADENAME_STORE_LOCALITY')}
                              variant="standard"
                              onBlur={handleBlurDataEditPurchaseDelivery}
                              onChange={handleChangeDataEditPurchaseDelivery}
                              disabled
                          />  
                      </div>
                    </div>

                    <div className="row p-2"> 
                      <div className="form-group"> 
                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PURCHASEDELIVERY_TRADENAME_STORE_OTHERS').toUpperCase()} :</label>    
                        &nbsp;&nbsp;&nbsp;&nbsp; 
                        <TextField
                          id="observations" 
                          name="observations"
                          value={formPurchaseDelivery.observations}
                          inputProps={{ style: {width: i18n.language==='es'?1327:1339,  fontSize: '18px', }, maxLength: 255 }}
                          style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                          placeholder={t('Placeholder_PURCHASEDELIVERY_TRADENAME_STORE_OTHERS')}
                          variant="standard"
                          onBlur={handleBlurDataEditPurchaseDelivery}
                          onChange={handleChangeDataEditPurchaseDelivery}
                        />
                        <hr className="sidebar-divider d-none d-md-block"/>
                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PurchaseDeliver_Payment').toUpperCase()} :</label>    
                        &nbsp;&nbsp;&nbsp;&nbsp; 
                        <TextField
                          id="payment_id"
                          name="payment_id"
                          value={ (formPurchaseDelivery.payment_id === undefined || formPurchaseDelivery.payment_id ===null || formPurchaseDelivery.payment_id ===""
                                || formPurchaseDelivery.payment_id ==="0" || formPurchaseDelivery.payment_id ===0)?2:formPurchaseDelivery.payment_id}
                          inputProps={{ style: {width: i18n.language==='es'?300:300,  fontSize: '18px', }, maxLength: 255 }}
                          style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                          variant="outlined"
                          onBlur={handleBlurDataEditPurchaseDelivery}
                          onChange={handleChangeDataEditPurchaseDelivery}
                          select
                          SelectProps={{
                            native: true,
                            value: (formPurchaseDelivery.payment_id === undefined || formPurchaseDelivery.payment_id ===null || formPurchaseDelivery.payment_id ===""
                                || formPurchaseDelivery.payment_id ==="0" || formPurchaseDelivery.payment_id ===0)?2: formPurchaseDelivery.payment_id
                          }}> 
                          {paymenetTypeSelect.map((option) => (
                          <option key={option.id} value={option.id}>
                              {i18n.language==="es"?option.namees:option.nameen}
                          </option>
                          ))}
                        </TextField>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PurchaseDeliver_TOTAL_WEIGHT').toUpperCase()} :</label>    
                        &nbsp;&nbsp;&nbsp;&nbsp; 
                        <NumericFormat
                          thousandSeparator=","
                          decimalSeparator="."
                          decimalScale={2}
                          fixedDecimalScale
                          allowNegative={false}
                          isAllowed={withValueCap3}
                          id="totalWeigthNeto"
                          name="totalWeigthNeto"
                          suffix=" Tn"
                          value={formPurchaseDelivery.totalWeigthNeto}
                          className="weight-field"
                          onBlur={(e) => handleBlurTotalWeightNeto(e.target.value)}
                          onChange={(e) => handleChangeTotalWeightNeto(e.target.value)}
                        /> 
                      </div>                              
                    </div>
                    <div className="formdi-pending-card-flat">
                      <div className="formdi-pending-card-content">
                        <TableSortingPurchaseDeliveryArticleList
                          dataArticles={formPurchaseDelivery.linespurchasedelivery} 
                          numTotRegArticles={formPurchaseDelivery.linespurchasedelivery.length}
                          setOpenDeleteRowArticles={setOpenDeleteRowArticles}
                          setEditRowArticles={setEditRowArticles}
                          formPurchaseDelivery={formPurchaseDelivery}                                  
                          setFormPurchaseDelivery={setFormPurchaseDelivery}
                          setShowModalSearchArticles={setShowModalSearchArticles}
                          LIMITPAGESIZE={LIMITPAGESIZE}
                          setShowModalSearchDI={setShowModalSearchDI}
                        />
                    </div>
                  </div>
                   <div className="formgeneral-card-form">
                      <div className="row p-2"> 
                        <Box className="signature-container">
                            <Card className="signature-card"> 
                              <CardContent className="signature-card-content">
                                {/* Canvas (fila 1, col 1) */}
                                <div className="signature-canvas">
                                  <SignatureCanvas
                                    penColor="black"
                                    ref={signDispatchedOptTrasCanvas}
                                    canvasProps={{
                                      width: CANVAS_SIZE,
                                      height: CANVAS_SIZE,
                                      style: {
                                        width: `${CANVAS_SIZE}px`,
                                        height: `${CANVAS_SIZE}px`,
                                        display: "block"
                                      }
                                    }}
                                  />
                                </div> 
                                {/* Columna lateral (col 2, filas 1-2) */}
                                <Box className="signature-side-col">
                                  <Button className="signature-side-btn" onClick={() => drawPredefinedSignature(CLIENTEFIRMA==="ARENA"?predefinedSignaturesArena[0]:predefinedSignaturesBentahor[0]) }>
                                    {TEXT_SIGN_1}
                                  </Button>
                                  <Button className="signature-side-btn" onClick={() => drawPredefinedSignature(CLIENTEFIRMA==="ARENA"?predefinedSignaturesArena[1]:predefinedSignaturesBentahor[1]) }>
                                    {TEXT_SIGN_2}
                                  </Button>
                                  <Button className="signature-side-btn" onClick={() => drawPredefinedSignature(CLIENTEFIRMA==="ARENA"?predefinedSignaturesArena[2]:predefinedSignaturesBentahor[2]) }>
                                    {TEXT_SIGN_3}
                                  </Button>
                                  <Button className="signature-side-btn" onClick={() => drawPredefinedSignature(CLIENTEFIRMA==="ARENA"?predefinedSignaturesArena[3]:predefinedSignaturesBentahor[3]) }>
                                    {TEXT_SIGN_4}
                                  </Button>
                                  <Button className="signature-side-btn" onClick={() => drawPredefinedSignature(CLIENTEFIRMA==="ARENA"?predefinedSignaturesArena[4]:predefinedSignaturesBentahor[4]) }>
                                    {TEXT_SIGN_5}
                                  </Button>
                                </Box> 
                                {/* Botón ELIMINAR (fila 2, col 1) */}
                                <div className="signature-delete">
                                  <Button
                                    className="signature-btn"
                                    size="small"
                                    onClick={() => deleteSignature(1)}
                                  >
                                    {t("Button_Delete")}
                                  </Button>
                                </div>
                              </CardContent> 
                              {/* Título debajo del botón eliminar */}
                              <Typography className="signature-title">
                                {t("Text_Signature_DispatchedBy")}
                              </Typography>
                            </Card>
                            <Card className="signature-card-client">
                              <CardContent className="signature-card-content-client">
                                <div className="signature-canvas-client">
                                  <SignatureCanvas
                                    penColor="black"
                                    ref={signDispatchedDestTrasCanvas}
                                    canvasProps={{
                                      width: CLIENT_CANVAS_WIDTH,
                                      height: CLIENT_CANVAS_HEIGHT,
                                      style: {
                                        width: `${CLIENT_CANVAS_WIDTH}px`,
                                        height: `${CLIENT_CANVAS_HEIGHT}px`,
                                        display: "block"
                                      }
                                    }}
                                  /> 
                                </div>
                                <div className="signature-delete-client">
                                  <Button className="signature-btn" size="small" onClick={() => deleteSignature(2)}>
                                    {t("Button_Delete")}
                                  </Button>
                                </div>
                              </CardContent>
                              <Typography className="signature-title">
                                {t("Text_Signature_client")}
                              </Typography>
                            </Card>
                          </Box>
                      </div>
                    </div> 
                    <div className="formgeneral-card-form">
                      <div className="row p-2"> 
                        <Box sx={{ width: "100%" }}>
                          <div className="empbtns-grid">
                            {articlesButtonsList.map((post, index) => (
                              <Button
                                key={index}
                                variant="contained"
                                className="empbtn-tile"
                                style={{ "--btn-base": post.button_color }}
                                onClick={() => selectArticle(post)}
                              >
                                {i18n.language === "es" ? post.button_namees : post.button_nameen}
                              </Button>
                            ))}
                          </div>
                        </Box> 
                      </div>
                    </div>
                  </div>    
                </>:
                  <LoadingNews/>
                }
              </form>
            </Box>
            <br/>
            
            <PurchaseDeliverySearchStores
              showModalSearchStores={showModalSearchStores}
              setShowModalSearchStores={setShowModalSearchStores}
              selectStores={tetxtSearch}
              setFormPurchaseDelivery={setFormPurchaseDelivery}
            />
            <PurchaseDeliverySearchVehicles
              showModalSearchVehicles={showModalSearchVehicles}
              setShowModalSearchVehicles={setShowModalSearchVehicles}
              setFormPurchaseDelivery={setFormPurchaseDelivery}
              formPurchaseDelivery={formPurchaseDelivery}
            /> 
            <PurchaseDeliverySearchStoresAddresses
              showModalSearchStoresAddress={showModalSearchStoresAddress}
              setShowModalSearchStoresAddress={setShowModalSearchStoresAddress}
              setFormPurchaseDelivery={setFormPurchaseDelivery}
              titleTable={formPurchaseDelivery.ori_tras_tradename}
              store_id={formPurchaseDelivery.ori_tras_store_id}
              priority={2}
            />
            <PurchaseDeliverySearchArticles
              showModalSearchArticles={showModalSearchArticles}
              setShowModalSearchArticles={setShowModalSearchArticles}
              formPurchaseDelivery={formPurchaseDelivery}                                  
              setFormPurchaseDelivery={setFormPurchaseDelivery} 
            /> 
            <PurchaseDeliverySearchDI
              showModalSearchDI={showModalSearchDI}
              setShowModalSearchDI={setShowModalSearchDI}
              editRowArticles={editRowArticles}
              setEditRowArticles={setEditRowArticles}
              formPurchaseDelivery={formPurchaseDelivery} 
              setFormPurchaseDelivery={setFormPurchaseDelivery} 
            /> 
             
            
            <Dialog open={openDeleteRowArticles} onClose={handleCancelDeleteRow}>
              <DialogTitle style={{color:"#e74a3b"}}>{t('Text_Delete')} {editRowArticles.indexrowarticle}  - {editRowArticles.article_code} - {i18n.language==='es'?editRowArticles.article_namees:editRowArticles.article_nameen} </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  {t('Text_Line1')}<br/>
                  {t('Text_Line2')}
                </DialogContentText>
                <TextField
                  autoFocus
                  margin="dense"
                  id="idCode"
                  label={t('Text_Label')}
                  type="text"
                  fullWidth
                  variant="standard"
                  error
                  defaultValue={idCodeDeletePurchaseDelivery}
                  onChange={handleChangeDeleteRow}/>
              </DialogContent>
              <DialogActions>
                <Button style={{color:"#e74a3b",fontSize: 16 }} onClick={handleCancelDeleteRow}>{t('Button_Cancel')}</Button>
                <Button variant="contained" style={{color:"#ffffff", background:"#e74a3b",fontSize: 16}} onClick={handleCloseDeleteRow}>{t('Button_Delete')}</Button>
              </DialogActions>
            </Dialog>
          </div>
        //* End Page Content *//
      ) :  null }
    </>
  )    
}

PurchaseDeliveryEditOrCreate.propTypes = {
  id: PropTypes.string.isRequired,
  showModalPurchasesDeliverySettings: PropTypes.bool.isRequired,
  typeOfList: PropTypes.string.isRequired
};

export default PurchaseDeliveryEditOrCreate;